export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** 
 * The `Naive DateTime` scalar type represents a naive date and time without
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string.
 */
  NaiveDateTime: any,
  /** 
 * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
 */
  Date: any,
  /** HTML rich text (e.g. used in WYSIWG). It's safe to use dangerouslySetInnerHTML on these. */
  HtmlRichText: any,
  /** 
 * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library.  The Decimal appears in a JSON
   * response as a string to preserve precision.
 */
  Decimal: any,
  /** ISO time */
  Timestamp: any,
};

export type AcceptOfferInput = {
  clientMutationId: Scalars['String'],
  /** Id of the contract */
  contractId: Scalars['ID'],
};

export type AcceptOfferPayload = {
   __typename?: 'AcceptOfferPayload',
  clientMutationId: Scalars['String'],
  contract?: Maybe<Contract>,
};

export type AcceptOrganisationInvitationInput = {
  clientMutationId: Scalars['String'],
  code: Scalars['String'],
};

export type AcceptOrganisationInvitationPayload = {
   __typename?: 'AcceptOrganisationInvitationPayload',
  clientMutationId: Scalars['String'],
  organisationInvitation?: Maybe<OrganisationInvitation>,
};

export type ActivateProjectInput = {
  clientMutationId: Scalars['String'],
  code: Scalars['String'],
};

export type ActivateProjectPayload = {
   __typename?: 'ActivateProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export type AddApplicationExperienceInput = {
  /** The project id of the application being applied to */
  applicationProjectId: Scalars['ID'],
  clientMutationId: Scalars['String'],
  /** The description to associate with a work history item or project */
  description?: Maybe<Scalars['String']>,
  /** The id of a project to associate a description with */
  projectId?: Maybe<Scalars['ID']>,
  /** The id of a work history item to associate a description with */
  workHistoryId?: Maybe<Scalars['ID']>,
};

export type AddApplicationExperiencePayload = {
   __typename?: 'AddApplicationExperiencePayload',
  application?: Maybe<ApplicationV2>,
  applicationExperience?: Maybe<ApplicationExperienceV2>,
  clientMutationId: Scalars['String'],
};

export type AddApplicationViewedInteractionInput = {
  /** Applicant id */
  applicantId?: Maybe<Scalars['ID']>,
  clientMutationId: Scalars['String'],
  /** Application project id */
  projectId?: Maybe<Scalars['ID']>,
};

export type AddApplicationViewedInteractionPayload = {
   __typename?: 'AddApplicationViewedInteractionPayload',
  application?: Maybe<ApplicationV2>,
  clientMutationId: Scalars['String'],
};

export type AddAvailabilityEventInput = {
  clientMutationId: Scalars['String'],
  /** The end of the availability event */
  dateEnd: Scalars['String'],
  /** The start of the availability event */
  dateStart: Scalars['String'],
  /** The type of availability */
  type: EventTypeV2,
};

export type AddAvailabilityEventPayload = {
   __typename?: 'AddAvailabilityEventPayload',
  clientMutationId: Scalars['String'],
  events?: Maybe<Array<Maybe<EventMutationOutputV2>>>,
};

export type AddExpertBankAccountInput = {
  accountName?: Maybe<Scalars['String']>,
  accountNumber?: Maybe<Scalars['String']>,
  accountTitle?: Maybe<Scalars['String']>,
  bankAccountType?: Maybe<BankAccountType>,
  beneficiaryAddress?: Maybe<Scalars['String']>,
  bsb?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  iban?: Maybe<Scalars['String']>,
  routingNumber?: Maybe<Scalars['String']>,
  swiftCode?: Maybe<Scalars['String']>,
};

export type AddExpertBankAccountPayload = {
   __typename?: 'AddExpertBankAccountPayload',
  bankAccountAus?: Maybe<BankAccountAus>,
  bankAccountInternational?: Maybe<BankAccountInternational>,
  bankAccountUs?: Maybe<BankAccountUs>,
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type AdminInviteToProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['String'],
  publicCode: Scalars['String'],
};

export type AdminInviteToProjectPayload = {
   __typename?: 'AdminInviteToProjectPayload',
  clientMutationId: Scalars['String'],
  message?: Maybe<Scalars['String']>,
  projectCode?: Maybe<Scalars['String']>,
  success?: Maybe<Scalars['Boolean']>,
};

export type ApplicantStatus = {
   __typename?: 'ApplicantStatus',
  expertDeclinedReason?: Maybe<Scalars['String']>,
  expertStatus?: Maybe<ExpertStatus>,
  expertStatusDate?: Maybe<Scalars['Timestamp']>,
  invited?: Maybe<Scalars['Boolean']>,
  recommended?: Maybe<Scalars['Boolean']>,
  viewed?: Maybe<Scalars['Boolean']>,
};

export type ApplicationExperienceV2 = Node & {
   __typename?: 'ApplicationExperienceV2',
  /** Description of a given work history item or project the applicant has worked on */
  description?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  item?: Maybe<ExperienceItemV2>,
  /** The project id this description relates to */
  projectId?: Maybe<Scalars['Int']>,
  /** The work history id this description relates to */
  workHistoryId?: Maybe<Scalars['Int']>,
};

export type ApplicationExperienceV2Connection = {
   __typename?: 'ApplicationExperienceV2Connection',
  edges?: Maybe<Array<Maybe<ApplicationExperienceV2Edge>>>,
  pageInfo: PageInfo,
};

export type ApplicationExperienceV2Edge = {
   __typename?: 'ApplicationExperienceV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<ApplicationExperienceV2>,
};

export enum ApplicationStatusV2 {
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum ApplicationSteps {
  AccountCreated = 'ACCOUNT_CREATED',
  AdditionalDetailsAnswered = 'ADDITIONAL_DETAILS_ANSWERED',
  CvUploaded = 'CV_UPLOADED',
  PurposeAnswered = 'PURPOSE_ANSWERED'
}

export type ApplicationV2 = Node & {
   __typename?: 'ApplicationV2',
  applicant?: Maybe<UserV2>,
  applicantStatus?: Maybe<ApplicantStatus>,
  budget?: Maybe<Scalars['String']>,
  dateStart?: Maybe<Scalars['String']>,
  dateSubmitted?: Maybe<Scalars['Timestamp']>,
  /** The ID of an object */
  id: Scalars['ID'],
  projectId?: Maybe<Scalars['Int']>,
  proposedRate?: Maybe<Scalars['Decimal']>,
  proposedRateUnit?: Maybe<Scalars['String']>,
  /** Work and project experiences associated with this application */
  selectedExperiences?: Maybe<ApplicationExperienceV2Connection>,
  statement?: Maybe<Scalars['String']>,
  status?: Maybe<ApplicationStatusV2>,
};


export type ApplicationV2SelectedExperiencesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type ApplicationV2Connection = {
   __typename?: 'ApplicationV2Connection',
  edges?: Maybe<Array<Maybe<ApplicationV2Edge>>>,
  pageInfo: PageInfo,
};

export type ApplicationV2Edge = {
   __typename?: 'ApplicationV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<ApplicationV2>,
};

export type ApproveContractOfferInput = {
  clientMutationId: Scalars['String'],
  email: Scalars['String'],
  password?: Maybe<Scalars['String']>,
  /** approval token */
  token: Scalars['String'],
};

export type ApproveContractOfferPayload = {
   __typename?: 'ApproveContractOfferPayload',
  alreadyApproved?: Maybe<Scalars['Boolean']>,
  clientMutationId: Scalars['String'],
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type AvailabilityV2 = {
   __typename?: 'AvailabilityV2',
  /** Current availability status for the expert based on availability event for current date */
  currentStatus?: Maybe<EventTypeV2>,
  events?: Maybe<EventV2Connection>,
};


export type AvailabilityV2EventsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  dateRange: EventDateRangeInput,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type AvailabilityV3 = {
   __typename?: 'AvailabilityV3',
  currentAvailability?: Maybe<AvailabilityStatus>,
  unavailableUntilDate?: Maybe<Scalars['Date']>,
};

export type BackOffice = {
   __typename?: 'BackOffice',
  backOfficeLink?: Maybe<Scalars['String']>,
  dateAvailabilityUpdated?: Maybe<Scalars['Timestamp']>,
  /** The most recent activity of any kind on the platform. */
  dateLastActivity?: Maybe<Scalars['Timestamp']>,
  dateLastBrowsedProjects?: Maybe<Scalars['Timestamp']>,
  dateLastInteracted?: Maybe<Scalars['Timestamp']>,
  dateLastLogin?: Maybe<Scalars['Timestamp']>,
  dateRegistered?: Maybe<Scalars['Timestamp']>,
  dateUserLastUpdated?: Maybe<Scalars['Timestamp']>,
  isFutured?: Maybe<Scalars['Boolean']>,
  isLocked?: Maybe<Scalars['Boolean']>,
  isPrivate?: Maybe<Scalars['Boolean']>,
};

export type BankAccountAus = {
   __typename?: 'BankAccountAus',
  accountName?: Maybe<Scalars['String']>,
  bsb?: Maybe<Scalars['String']>,
};

export type BankAccountInternational = {
   __typename?: 'BankAccountInternational',
  accountName?: Maybe<Scalars['String']>,
  beneficiaryAddress?: Maybe<Scalars['String']>,
  swiftCode?: Maybe<Scalars['String']>,
};

export enum BankAccountType {
  Aus = 'AUS',
  International = 'INTERNATIONAL',
  Payoneer = 'PAYONEER',
  Paypal = 'PAYPAL',
  Us = 'US'
}

export type BankAccountUs = {
   __typename?: 'BankAccountUs',
  accountTitle?: Maybe<Scalars['String']>,
  beneficiaryAddress?: Maybe<Scalars['String']>,
  routingNumber?: Maybe<Scalars['String']>,
  swiftCode?: Maybe<Scalars['String']>,
};

/** A list of bookmarked objects */
export type Bookmark = Project;

export type BookmarkConnection = {
   __typename?: 'BookmarkConnection',
  edges?: Maybe<Array<Maybe<BookmarkEdge>>>,
  pageInfo: PageInfo,
};

export type BookmarkEdge = {
   __typename?: 'BookmarkEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Bookmark>,
};

export enum BudgetType {
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}

export enum BudgetUnit {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR',
  PerMonth = 'PER_MONTH',
  PerProject = 'PER_PROJECT',
  PerWeek = 'PER_WEEK'
}

/** Business Services */
export type BusinessService = Node & {
   __typename?: 'BusinessService',
  group: Scalars['String'],
  /** The ID of an object */
  id: Scalars['ID'],
  isApproved: Scalars['Boolean'],
  name: Scalars['String'],
};

export type BusinessServiceConnection = {
   __typename?: 'BusinessServiceConnection',
  edges?: Maybe<Array<Maybe<BusinessServiceEdge>>>,
  pageInfo: PageInfo,
};

export type BusinessServiceEdge = {
   __typename?: 'BusinessServiceEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<BusinessService>,
};

export type CancelProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type CancelProjectPayload = {
   __typename?: 'CancelProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export enum ClientProjectFilter {
  Archived = 'ARCHIVED',
  Filled = 'FILLED',
  Sourcing = 'SOURCING'
}

export type ClientV2 = {
   __typename?: 'ClientV2',
  /** A single contract viewable by the client given the contract code */
  contract?: Maybe<Contract>,
  isOrgAdmin?: Maybe<Scalars['Boolean']>,
  memberOf: Array<Organisation>,
  phoneMobile?: Maybe<Scalars['String']>,
  postedProjects?: Maybe<Array<Maybe<PostedProject>>>,
  profilePicture?: Maybe<ProfilePicture>,
  profileUrl?: Maybe<Scalars['String']>,
  /** A single project viewable by the client given the project code */
  project?: Maybe<ProjectV2>,
  /** A collection of projects for the client. */
  projects?: Maybe<ProjectV2Connection>,
  title?: Maybe<Scalars['String']>,
};


export type ClientV2ContractArgs = {
  code?: Maybe<Scalars['String']>
};


export type ClientV2ProfilePictureArgs = {
  size: ProfilePictureSize
};


export type ClientV2ProjectArgs = {
  code?: Maybe<Scalars['String']>
};


export type ClientV2ProjectsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<ClientProjectFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export enum ConsultantBusinessType {
  IndependentExpert = 'INDEPENDENT_EXPERT',
  MemberOfFirm = 'MEMBER_OF_FIRM'
}

export type ConsultantV2 = Node & {
   __typename?: 'ConsultantV2',
  availability?: Maybe<AvailabilityV2>,
  /** Average Project Rating for an expert */
  averageProjectRating?: Maybe<Scalars['Float']>,
  /** A collection of projects for the consulant. */
  dashboardProjects?: Maybe<ProjectV2Connection>,
  expertAvailability?: Maybe<AvailabilityV3>,
  /** A collection of projects for which the consulant has an agreed contract. */
  hiredProjects?: Maybe<ProjectV2Connection>,
  /** The ID of an object */
  id: Scalars['ID'],
  /** Insurance information for an expert */
  insuranceInformation?: Maybe<InsuranceInformation>,
  /** Is this consultant a talent of any private cloud */
  isPrivateCloudMember?: Maybe<Scalars['Boolean']>,
  /** Expert lifecycle information */
  lifecycle?: Maybe<Lifecycle>,
  /** The organisations this consultant is a member of */
  memberOf: Array<Organisation>,
  /** Expert payment information */
  paymentInformation?: Maybe<PaymentInformationV2>,
  private?: Maybe<Scalars['Boolean']>,
  profile?: Maybe<ProfileV2>,
  /** Profile privacy setting for an expert */
  profilePrivacy?: Maybe<ExpertProfilePrivacy>,
  /** Project count for an expert */
  projectCount?: Maybe<Scalars['Int']>,
  /** A collection of work history for the consultant. */
  workHistory?: Maybe<WorkHistoryV2Connection>,
};


export type ConsultantV2DashboardProjectsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  expertStage?: Maybe<ExpertStages>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ConsultantV2HiredProjectsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  includeUnlisted?: Maybe<Scalars['Boolean']>,
  last?: Maybe<Scalars['Int']>
};


export type ConsultantV2WorkHistoryArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type Contact = Node & {
   __typename?: 'Contact',
  engagementType?: Maybe<EngagementType>,
  firstname?: Maybe<Scalars['String']>,
  headline?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  isViewer?: Maybe<Scalars['Boolean']>,
  lastname?: Maybe<Scalars['String']>,
  organisations?: Maybe<Array<Organisation>>,
  profilePicture?: Maybe<ProfilePicture>,
  profileUrl?: Maybe<Scalars['String']>,
};


export type ContactProfilePictureArgs = {
  size: ProfilePictureSize
};

export type ContactConnection = {
   __typename?: 'ContactConnection',
  edges?: Maybe<Array<Maybe<ContactEdge>>>,
  pageInfo: PageInfo,
  totalCount: Scalars['Int'],
};

export type ContactEdge = {
   __typename?: 'ContactEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Contact>,
};

/** A contract is an agreement between a consultant client for work on a project. */
export type Contract = Node & {
   __typename?: 'Contract',
  agreedDate?: Maybe<Scalars['Timestamp']>,
  allowReimbursements?: Maybe<Scalars['Boolean']>,
  /** The fee agreed to be paid */
  amount?: Maybe<Scalars['Float']>,
  /** Application id for the contract */
  applicationId?: Maybe<Scalars['ID']>,
  budgetType?: Maybe<Scalars['String']>,
  budgetUnit?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  createdDate?: Maybe<Scalars['Timestamp']>,
  currency?: Maybe<Scalars['String']>,
  detail?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['Int']>,
  durationUnit?: Maybe<Scalars['String']>,
  endDate?: Maybe<Scalars['Timestamp']>,
  expensesCovered?: Maybe<Scalars['String']>,
  expert?: Maybe<User>,
  /** The ID of an object */
  id: Scalars['ID'],
  milestones?: Maybe<Scalars['String']>,
  /** All agreed upon or extended contracts related to this contract (in the same series) */
  relatedContracts?: Maybe<Array<Maybe<Contract>>>,
  requiredReceipts?: Maybe<Scalars['Boolean']>,
  review?: Maybe<RatingAndReview>,
  startDate?: Maybe<Scalars['Timestamp']>,
  status?: Maybe<ContractStatus>,
  /** Terms for the current user (either client or expert) */
  terms?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type ContractConnection = {
   __typename?: 'ContractConnection',
  edges?: Maybe<Array<Maybe<ContractEdge>>>,
  pageInfo: PageInfo,
};

export type ContractEdge = {
   __typename?: 'ContractEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Contract>,
};

export enum ContractingCompany {
  NonPayrolled = 'NON_PAYROLLED',
  Payrolled = 'PAYROLLED'
}

export enum ContractStatus {
  ProjectContractAgreed = 'PROJECT_CONTRACT_AGREED',
  ProjectContractConsultantOffered = 'PROJECT_CONTRACT_CONSULTANT_OFFERED',
  ProjectContractCounteroffer = 'PROJECT_CONTRACT_COUNTEROFFER',
  ProjectContractExtended = 'PROJECT_CONTRACT_EXTENDED',
  ProjectContractModified = 'PROJECT_CONTRACT_MODIFIED',
  ProjectContractOffered = 'PROJECT_CONTRACT_OFFERED'
}

/** A country object. */
export type Country = Node & {
   __typename?: 'Country',
  /** The alpha2 code, e.g. AU for Australia */
  alpha2Code?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  /** The country name, e.g. Australia */
  name?: Maybe<Scalars['String']>,
};

export type CreateEducationItemInput = {
  clientMutationId: Scalars['String'],
  educationItem?: Maybe<EducationItemInput>,
  profileCode: Scalars['String'],
};

export type CreateEducationItemPayload = {
   __typename?: 'CreateEducationItemPayload',
  clientMutationId: Scalars['String'],
  educationItem?: Maybe<EducationItem>,
};

export type CreateFavouriteInput = {
  clientMutationId: Scalars['String'],
  userId: Scalars['ID'],
};

export type CreateFavouritePayload = {
   __typename?: 'CreateFavouritePayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<User>,
};

export type CreateMessageInput = {
  body: Scalars['String'],
  clientMutationId: Scalars['String'],
  recipientId: Scalars['ID'],
  senderId: Scalars['ID'],
};

export type CreateMessagePayload = {
   __typename?: 'CreateMessagePayload',
  clientMutationId: Scalars['String'],
  thread?: Maybe<ThreadEdge>,
};

export type CreateOfferInput = {
  /** Whether reimbursements are allowed */
  allowReimbursements?: Maybe<Scalars['Boolean']>,
  /** The amount of currency that will be paid */
  amount?: Maybe<Scalars['Float']>,
  /** Project application id */
  applicationId?: Maybe<Scalars['ID']>,
  /** The type of budget for this contract */
  budgetType?: Maybe<BudgetType>,
  /** The budget unit e.g. per-day */
  budgetUnit?: Maybe<BudgetUnit>,
  clientMutationId: Scalars['String'],
  /** Type of currency the payment will be in */
  currency?: Maybe<Scalars['String']>,
  /** Additional comments around deliverables, timeframes or fees */
  detail?: Maybe<Scalars['String']>,
  /** The length of the contract */
  duration?: Maybe<Scalars['String']>,
  /** The unit of length for the contract */
  durationUnit?: Maybe<DurationUnit>,
  /** Description of the expenses covered */
  expensesCovered?: Maybe<Scalars['String']>,
  /** Deliverables for the contract */
  milestones?: Maybe<Scalars['String']>,
  /** The note to send along to the expert with the contract */
  notes?: Maybe<Scalars['String']>,
  /** Public code of the client or expert being offered the contract */
  offeredUserCode: Scalars['String'],
  /** Project id of the contract */
  projectId: Scalars['ID'],
  /** If receipts are required to pay for expenses */
  requiredReceipts?: Maybe<Scalars['Boolean']>,
  /** Start date for the project */
  startDate: Scalars['NaiveDateTime'],
  /** Title of the contract */
  title: Scalars['String'],
};

export type CreateOfferPayload = {
   __typename?: 'CreateOfferPayload',
  clientMutationId: Scalars['String'],
  contract?: Maybe<Contract>,
};

export type CreateOrganisationInvitationInput = {
  clientMutationId: Scalars['String'],
  email: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
};

export type CreateOrganisationInvitationPayload = {
   __typename?: 'CreateOrganisationInvitationPayload',
  clientMutationId: Scalars['String'],
  organisationInvitation?: Maybe<OrganisationInvitation>,
  status?: Maybe<InvitationSentStatus>,
};

export type CreateProjectBookmarkInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type CreateProjectBookmarkPayload = {
   __typename?: 'CreateProjectBookmarkPayload',
  clientMutationId: Scalars['String'],
  searchProject?: Maybe<SearchProject>,
};

export type CreateProjectInput = {
  clientMutationId: Scalars['String'],
  projectBrief?: Maybe<ProjectBriefInput>,
};

export type CreateProjectPayload = {
   __typename?: 'CreateProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export type CreateWorkItemInput = {
  clientMutationId: Scalars['String'],
  workItem?: Maybe<WorkItemInput>,
};

export type CreateWorkItemPayload = {
   __typename?: 'CreateWorkItemPayload',
  clientMutationId: Scalars['String'],
  lifecycle?: Maybe<Lifecycle>,
  workItem?: Maybe<WorkHistoryV2>,
};

export enum Currency {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}


/** Accepts a start and end date */
export type DateRangeInput = {
  endDate?: Maybe<Scalars['String']>,
  startDate?: Maybe<Scalars['String']>,
};


export type DeclinedInvitation = {
   __typename?: 'DeclinedInvitation',
  date?: Maybe<Scalars['Timestamp']>,
};

export type DeclineExpertApplicationInput = {
  /** Applicant id */
  applicantId?: Maybe<Scalars['ID']>,
  clientMutationId: Scalars['String'],
  /** Content */
  content?: Maybe<Scalars['String']>,
  /** Application project id */
  projectId?: Maybe<Scalars['ID']>,
};

export type DeclineExpertApplicationPayload = {
   __typename?: 'DeclineExpertApplicationPayload',
  application?: Maybe<ApplicationV2>,
  clientMutationId: Scalars['String'],
};

export type DeleteEducationItemInput = {
  clientMutationId: Scalars['String'],
  educationItemId: Scalars['ID'],
};

export type DeleteEducationItemPayload = {
   __typename?: 'DeleteEducationItemPayload',
  clientMutationId: Scalars['String'],
  educationItem?: Maybe<EducationItem>,
};

export type DeleteExpertBankAccountInput = {
  bankAccountType?: Maybe<BankAccountType>,
  clientMutationId: Scalars['String'],
};

export type DeleteExpertBankAccountPayload = {
   __typename?: 'DeleteExpertBankAccountPayload',
  clientMutationId: Scalars['String'],
  confirmation?: Maybe<Scalars['Boolean']>,
};

export type DeleteWorkItemInput = {
  clientMutationId: Scalars['String'],
  workItemId: Scalars['ID'],
};

export type DeleteWorkItemPayload = {
   __typename?: 'DeleteWorkItemPayload',
  clientMutationId: Scalars['String'],
  workItem?: Maybe<WorkHistoryV2>,
};

export type Deliverable = Node & {
   __typename?: 'Deliverable',
  amount?: Maybe<Scalars['Decimal']>,
  description?: Maybe<Scalars['String']>,
  dueDate?: Maybe<Scalars['NaiveDateTime']>,
  /** The ID of an object */
  id: Scalars['ID'],
  invoiceOnly?: Maybe<Scalars['Boolean']>,
  note?: Maybe<Scalars['String']>,
  paymentInvoiceId?: Maybe<Scalars['Int']>,
};

export type DeliverableInput = {
  amount?: Maybe<Scalars['Decimal']>,
  description?: Maybe<Scalars['String']>,
  dueDate?: Maybe<Scalars['NaiveDateTime']>,
  invoiceOnly?: Maybe<Scalars['Boolean']>,
  note?: Maybe<Scalars['String']>,
};

export type Discipline = Node & {
   __typename?: 'Discipline',
  /** The ID of an object */
  id: Scalars['ID'],
  name: Scalars['String'],
};

export type DisciplineConnection = {
   __typename?: 'DisciplineConnection',
  edges?: Maybe<Array<Maybe<DisciplineEdge>>>,
  pageInfo: PageInfo,
};

export type DisciplineEdge = {
   __typename?: 'DisciplineEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Discipline>,
};

export enum DurationUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type EditTimesheetInput = {
  clientMutationId: Scalars['String'],
  code?: Maybe<Scalars['String']>,
  dateEnd: Scalars['NaiveDateTime'],
  dateStart: Scalars['NaiveDateTime'],
  rate?: Maybe<Scalars['Decimal']>,
  timesheets?: Maybe<Array<Maybe<TimesheetInput>>>,
};

export type EditTimesheetPayload = {
   __typename?: 'EditTimesheetPayload',
  clientMutationId: Scalars['String'],
  paymentInvoice?: Maybe<PaymentInvoice>,
};

export type EducationItem = Node & {
   __typename?: 'EducationItem',
  activities?: Maybe<Scalars['String']>,
  degree?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  endYear?: Maybe<Scalars['Int']>,
  fieldOfStudy?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  schoolName?: Maybe<Scalars['String']>,
  startYear?: Maybe<Scalars['Int']>,
  title?: Maybe<Scalars['String']>,
};

/** Education Item details */
export type EducationItemInput = {
  degree: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  endYear: Scalars['Int'],
  fieldOfStudy: Scalars['String'],
  schoolName: Scalars['String'],
  startYear: Scalars['Int'],
};

/** Interaction engagement types */
export enum EngagementType {
  Hired = 'HIRED',
  Interviewed = 'INTERVIEWED'
}

export type EventDateRangeInput = {
  dateEnd: Scalars['String'],
  dateStart: Scalars['String'],
};

export type EventMutationOutputV2 = {
   __typename?: 'EventMutationOutputV2',
  event?: Maybe<EventV2>,
  status?: Maybe<EventStatusV2>,
};

export enum EventStatusV2 {
  Deleted = 'DELETED',
  Inserted = 'INSERTED',
  Updated = 'UPDATED'
}

export enum EventType {
  FullTimeAvailable = 'FULL_TIME_AVAILABLE',
  PartTimeAvailable = 'PART_TIME_AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export enum EventTypeV2 {
  FullTimeAvailable = 'FULL_TIME_AVAILABLE',
  PartTimeAvailable = 'PART_TIME_AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type EventV2 = Node & {
   __typename?: 'EventV2',
  dateEnd?: Maybe<Scalars['Timestamp']>,
  dateStart?: Maybe<Scalars['Timestamp']>,
  /** The ID of an object */
  id: Scalars['ID'],
  type?: Maybe<EventTypeV2>,
};

export type EventV2Connection = {
   __typename?: 'EventV2Connection',
  edges?: Maybe<Array<Maybe<EventV2Edge>>>,
  pageInfo: PageInfo,
};

export type EventV2Edge = {
   __typename?: 'EventV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<EventV2>,
};

export type Expense = {
   __typename?: 'Expense',
  amount?: Maybe<Scalars['Decimal']>,
  date?: Maybe<Scalars['NaiveDateTime']>,
  description?: Maybe<Scalars['String']>,
  gst?: Maybe<Scalars['Decimal']>,
  receiptFileName?: Maybe<Scalars['String']>,
  receiptFileUuid?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
};

export type ExpenseInput = {
  amount: Scalars['Decimal'],
  date: Scalars['NaiveDateTime'],
  description?: Maybe<Scalars['String']>,
  gst: Scalars['Decimal'],
  receiptFileName?: Maybe<Scalars['String']>,
  receiptFileUuid?: Maybe<Scalars['String']>,
  type: Scalars['String'],
};

/** The project or work history item that is relevant experience for the application */
export type ExperienceItemV2 = ProjectV2 | WorkHistoryV2;

export type Expert = {
  applicationNotes?: Maybe<Scalars['String']>,
  operatingType?: Maybe<OperatingType>,
  registeredBusinessName?: Maybe<Scalars['String']>,
  uploadedCv?: Maybe<Scalars['String']>,
  workingSituation?: Maybe<WorkingSituation>,
};

export type ExpertFilterInput = {
  /** 
 * Only include experts who are more likely to apply to a project.
   * 
   * This is determined from how recently the expert applied to a project,
   * updated their profile, updated availability, etc.
   * 
   * Experts who are unavailable for the next 3 months or 'futured' will also be excluded.
 */
  approachable?: Maybe<Scalars['Boolean']>,
  /** 
 * 2-character country code, eg: "AU", "UK", "FR".
   * 
   * Only experts based in the given country will be included in the search results.
 */
  countryCode?: Maybe<Scalars['String']>,
  /** Name of the primary discipline of the expert, eg: "Corporate Development" */
  discipline?: Maybe<Scalars['String']>,
  /** Name of industries the expert has previously worked in, eg: ["Diversified Financial Services"] */
  industries?: Maybe<Array<Scalars['String']>>,
  /** 
 * Node ID from a Location object.
   * 
   * The geo coordinates of the location will be used to find
   * experts within a pre-configured radius of this location.
 */
  locationId?: Maybe<Scalars['ID']>,
  /** Names of organisations the expert has previously worked with, eg: ["Bain & Co", "PWC"] */
  organisationNames?: Maybe<Array<Scalars['String']>>,
  /** Limits search results to experts with rate range that overlaps a given rate range. */
  rate?: Maybe<ExpertFilterRateInput>,
  /** Name of a role title held at a previous position, eg: "Management Consultant" */
  roleTitle?: Maybe<Scalars['String']>,
  /** Names of role title held at previous positions, eg: ["Management Consultant", "Change Manager"] */
  roleTitles?: Maybe<Array<Scalars['String']>>,
  /** Free-form search keywords will be matched against the experts profile, work history and skills. */
  searchTerm?: Maybe<Scalars['String']>,
  /** Names of required skills, eg: ["Change Management", "Financial Analysis"] */
  skills?: Maybe<Array<Scalars['String']>>,
};

export type ExpertFilterRateInput = {
  currency: Currency,
  rateMax: Scalars['Decimal'],
  rateMin: Scalars['Decimal'],
  unit: ExpertRateUnit,
};

export type ExpertOrganisationInput = {
  id?: Maybe<Scalars['ID']>,
  name?: Maybe<Scalars['String']>,
};

export enum ExpertProfilePrivacy {
  Expert360Clients = 'EXPERT360_CLIENTS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ExpertRateUnit {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR'
}

export enum ExpertStages {
  Applied = 'APPLIED',
  Completed = 'COMPLETED',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING',
  Invited = 'INVITED',
  Offered = 'OFFERED',
  PastApplied = 'PAST_APPLIED',
  PastInterviewed = 'PAST_INTERVIEWED',
  Saved = 'SAVED'
}

export enum ExpertStatus {
  ApplicationDeclined = 'APPLICATION_DECLINED',
  Applied = 'APPLIED',
  Closed = 'CLOSED',
  ExpertDeclined = 'EXPERT_DECLINED',
  Hired = 'HIRED',
  InterviewRequested = 'INTERVIEW_REQUESTED',
  Invited = 'INVITED',
  Matched = 'MATCHED',
  OfferModificationReceived = 'OFFER_MODIFICATION_RECEIVED',
  OfferModificationSent = 'OFFER_MODIFICATION_SENT',
  OfferReceived = 'OFFER_RECEIVED',
  OfferSent = 'OFFER_SENT'
}

export enum ExpertWorkingRightsV2 {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Unsure = 'UNSURE',
  Yes = 'YES'
}

export type FeedbackSkill = {
   __typename?: 'FeedbackSkill',
  title: Scalars['String'],
};

export type FeedbackSkillRating = {
   __typename?: 'FeedbackSkillRating',
  feedbackSkill: FeedbackSkill,
  rating?: Maybe<Scalars['Float']>,
};

export type FeedbackUserPublic = {
   __typename?: 'FeedbackUserPublic',
  rating?: Maybe<Scalars['Float']>,
  review?: Maybe<Scalars['String']>,
};


export type Industry = Node & {
   __typename?: 'Industry',
  /** The ID of an object */
  id: Scalars['ID'],
  isHidden?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
  parentId?: Maybe<Scalars['Int']>,
  parentName?: Maybe<Scalars['String']>,
};

export type IndustryConnection = {
   __typename?: 'IndustryConnection',
  edges?: Maybe<Array<Maybe<IndustryEdge>>>,
  pageInfo: PageInfo,
};

export type IndustryEdge = {
   __typename?: 'IndustryEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Industry>,
};

export type IndustryInput = {
  id?: Maybe<Scalars['ID']>,
};

export type InsuranceInformation = {
   __typename?: 'InsuranceInformation',
  hasInsurance?: Maybe<Scalars['Boolean']>,
  professionalIndemnityLimitInMillion?: Maybe<Scalars['Int']>,
  publicLiabilityLimitInMillion?: Maybe<Scalars['Int']>,
  workersCompensationCover?: Maybe<Scalars['Boolean']>,
};

export enum InvitationMessageStatus {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Invited = 'INVITED',
  Sent = 'SENT'
}

export enum InvitationSentStatus {
  New = 'NEW',
  Resent = 'RESENT'
}

export type InviteExpertToInterviewInput = {
  /** Applicant id */
  applicantId?: Maybe<Scalars['ID']>,
  clientMutationId: Scalars['String'],
  /** Application project id */
  projectId?: Maybe<Scalars['ID']>,
};

export type InviteExpertToInterviewPayload = {
   __typename?: 'InviteExpertToInterviewPayload',
  application?: Maybe<ApplicationV2>,
  clientMutationId: Scalars['String'],
};

export type InviteToProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['String'],
  publicCode: Scalars['String'],
};

export type InviteToProjectPayload = {
   __typename?: 'InviteToProjectPayload',
  clientMutationId: Scalars['String'],
  message?: Maybe<Scalars['String']>,
  projectCode?: Maybe<Scalars['String']>,
  success?: Maybe<Scalars['Boolean']>,
};

export type Invoice = Node & {
   __typename?: 'Invoice',
  amount?: Maybe<Scalars['Decimal']>,
  dateEnd?: Maybe<Scalars['NaiveDateTime']>,
  dateStart?: Maybe<Scalars['NaiveDateTime']>,
  /** The ID of an object */
  id: Scalars['ID'],
  invoiceOnlyDeliverables?: Maybe<Array<Maybe<Deliverable>>>,
};

export enum InvoiceStatus {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED',
  TimesheetRejected = 'TIMESHEET_REJECTED'
}

export type LegacyApplicationV2 = Node & {
   __typename?: 'LegacyApplicationV2',
  dateSubmitted?: Maybe<Scalars['Timestamp']>,
  /** The ID of an object */
  id: Scalars['ID'],
  summary?: Maybe<Scalars['String']>,
};

export type LegacyApplicationV2Connection = {
   __typename?: 'LegacyApplicationV2Connection',
  edges?: Maybe<Array<Maybe<LegacyApplicationV2Edge>>>,
  pageInfo: PageInfo,
};

export type LegacyApplicationV2Edge = {
   __typename?: 'LegacyApplicationV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<LegacyApplicationV2>,
};

export type LegacyLocation = Node & {
   __typename?: 'LegacyLocation',
  city?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  subdivision?: Maybe<Scalars['String']>,
};

export type LegacyLocationConnection = {
   __typename?: 'LegacyLocationConnection',
  edges?: Maybe<Array<Maybe<LegacyLocationEdge>>>,
  pageInfo: PageInfo,
};

export type LegacyLocationEdge = {
   __typename?: 'LegacyLocationEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<LegacyLocation>,
};

export type LegacyOrganisation = Node & {
   __typename?: 'LegacyOrganisation',
  /** The ID of an object */
  id: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
};

export type LegacyOrganisationConnection = {
   __typename?: 'LegacyOrganisationConnection',
  edges?: Maybe<Array<Maybe<LegacyOrganisationEdge>>>,
  pageInfo: PageInfo,
};

export type LegacyOrganisationEdge = {
   __typename?: 'LegacyOrganisationEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<LegacyOrganisation>,
};

export type Lifecycle = Node & {
   __typename?: 'Lifecycle',
  accepted?: Maybe<Scalars['Boolean']>,
  applicationCompleted?: Maybe<Scalars['Boolean']>,
  applicationStep?: Maybe<ApplicationSteps>,
  basicProfileCompleted?: Maybe<Scalars['Boolean']>,
  declined?: Maybe<Scalars['Boolean']>,
  emailVerified?: Maybe<Scalars['Boolean']>,
  futured?: Maybe<Scalars['Boolean']>,
  /** The ID of an object */
  id: Scalars['ID'],
  locked?: Maybe<Scalars['Boolean']>,
  marketplaceMember?: Maybe<Scalars['Boolean']>,
  moreInfoRequired?: Maybe<Scalars['Boolean']>,
  privateCloudTalent?: Maybe<Scalars['Boolean']>,
};

export enum LifecycleModifier {
  ApplicationsPaused = 'APPLICATIONS_PAUSED',
  OnHold = 'ON_HOLD'
}

export enum LifecycleStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Hired = 'HIRED',
  Open = 'OPEN'
}

export type Message = Node & {
   __typename?: 'Message',
  body?: Maybe<Scalars['String']>,
  dateCreated?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  read: Scalars['Boolean'],
  recipient?: Maybe<Contact>,
  sender?: Maybe<Contact>,
};

export enum MessageStatus {
  New = 'NEW',
  RepliedToYou = 'REPLIED_TO_YOU'
}

export type ModifyOfferInput = {
  /** Whether reimbursements are allowed */
  allowReimbursements?: Maybe<Scalars['Boolean']>,
  /** The amount of currency that will be paid */
  amount?: Maybe<Scalars['Float']>,
  /** The type of budget for this contract */
  budgetType?: Maybe<BudgetType>,
  /** The budget unit e.g. per-day */
  budgetUnit?: Maybe<BudgetUnit>,
  clientMutationId: Scalars['String'],
  /** Id of the contract */
  contractId: Scalars['ID'],
  /** Type of currency the payment will be in */
  currency?: Maybe<Scalars['String']>,
  /** Additional comments around deliverables, timeframes or fees */
  detail?: Maybe<Scalars['String']>,
  /** The length of the contract */
  duration?: Maybe<Scalars['String']>,
  /** The unit of length for the contract */
  durationUnit?: Maybe<DurationUnit>,
  /** Description of the expenses covered */
  expensesCovered?: Maybe<Scalars['String']>,
  /** Deliverables for the contract */
  milestones?: Maybe<Scalars['String']>,
  /** The note to send along to the expert with the contract */
  notes?: Maybe<Scalars['String']>,
  /** If receipts are required to pay for expenses */
  requiredReceipts?: Maybe<Scalars['Boolean']>,
  /** Start date for the project */
  startDate: Scalars['NaiveDateTime'],
  /** Title of the contract */
  title: Scalars['String'],
};

export type ModifyOfferPayload = {
   __typename?: 'ModifyOfferPayload',
  clientMutationId: Scalars['String'],
  contract?: Maybe<Contract>,
};

/** Mutations */
export type Mutation = {
   __typename?: 'Mutation',
  /** Accept a contract offer */
  acceptOffer?: Maybe<AcceptOfferPayload>,
  /** Accept a private invite to a cloud */
  acceptOrganisationInvitation?: Maybe<AcceptOrganisationInvitationPayload>,
  /** Activate project */
  activateProject?: Maybe<ActivateProjectPayload>,
  /** Persist selected experience for an application */
  addApplicationExperience?: Maybe<AddApplicationExperiencePayload>,
  /** Marks project application as viewed */
  addApplicationViewedInteraction?: Maybe<AddApplicationViewedInteractionPayload>,
  /** Add consultant availability */
  addAvailabilityEvent?: Maybe<AddAvailabilityEventPayload>,
  /** add an expert bank account */
  addExpertBankAccount?: Maybe<AddExpertBankAccountPayload>,
  /** Submit invitation to project as admin */
  adminInviteToProject?: Maybe<AdminInviteToProjectPayload>,
  /** Anonymously approve an contract that will be offered to an expert (payload received via email) */
  approveContractOffer?: Maybe<ApproveContractOfferPayload>,
  /** Submit mutation to cancel a project */
  cancelProject?: Maybe<CancelProjectPayload>,
  /** Create an Education Item on Profile */
  createEducationItem?: Maybe<CreateEducationItemPayload>,
  /** Add the specified user to the viewer's favourites */
  createFavourite?: Maybe<CreateFavouritePayload>,
  /** Create a direct message between the current user and contact */
  createMessage?: Maybe<CreateMessagePayload>,
  /** Create a contract offer */
  createOffer?: Maybe<CreateOfferPayload>,
  /** Invite a user to an organisation */
  createOrganisationInvitation?: Maybe<CreateOrganisationInvitationPayload>,
  /** Submit mutation to create project */
  createProject?: Maybe<CreateProjectPayload>,
  /** Add the specified project to the viewer's bookmarks */
  createProjectBookmark?: Maybe<CreateProjectBookmarkPayload>,
  /** Create a work item on an Expert profile */
  createWorkItem?: Maybe<CreateWorkItemPayload>,
  /** Inserts expert declined interaction */
  declineExpertApplication?: Maybe<DeclineExpertApplicationPayload>,
  /** Delete an Education Item on Profile */
  deleteEducationItem?: Maybe<DeleteEducationItemPayload>,
  /** delete an expert bank account */
  deleteExpertBankAccount?: Maybe<DeleteExpertBankAccountPayload>,
  /** Delete a work item on an Expert profile */
  deleteWorkItem?: Maybe<DeleteWorkItemPayload>,
  /** Edit an invoice's timesheet */
  editTimesheet?: Maybe<EditTimesheetPayload>,
  /** Inserts interviewed interaction and sends emails to client and expert */
  inviteExpertToInterview?: Maybe<InviteExpertToInterviewPayload>,
  /** Submit invitation to project as client */
  inviteToProject?: Maybe<InviteToProjectPayload>,
  /** Modify a contract offer */
  modifyOffer?: Maybe<ModifyOfferPayload>,
  /** Submit mutation to onhold a project */
  onholdProject?: Maybe<OnholdProjectPayload>,
  /** Create an account for a new private cloud invitee */
  organisationInvitationCreateAccount?: Maybe<OrganisationInvitationCreateAccountPayload>,
  /** Submit mutation to pause a project */
  pauseProject?: Maybe<PauseProjectPayload>,
  /** Submit mutation to publish a project */
  publishProject?: Maybe<PublishProjectPayload>,
  /** Remove the specified user from the viewer's favourites */
  removeFavourite?: Maybe<RemoveFavouritePayload>,
  /** Remove the specified project from the viewer's bookmarks */
  removeProjectBookmark?: Maybe<RemoveProjectBookmarkPayload>,
  removeSavedBookmark?: Maybe<RemoveSavedBookmarkPayload>,
  /** request password reset */
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>,
  /** Resend organisation invitation */
  resendOrganisationInvitation?: Maybe<ResendOrganisationInvitationPayload>,
  /** Review a timesheet associated with an invoice */
  reviewTimesheet?: Maybe<ReviewTimesheetPayload>,
  /** Review a timesheet associated with an invoice anonymously */
  reviewTimesheetAnonymously?: Maybe<ReviewTimesheetAnonymouslyPayload>,
  /** Submit an application to a project */
  submitApplication?: Maybe<SubmitApplicationPayload>,
  /** Submit decline invitation */
  submitDeclineInvitation?: Maybe<SubmitDeclineInvitationPayload>,
  /** submit expert application */
  submitExpertApplication?: Maybe<SubmitExpertApplicationPayload>,
  /** Provide consultant insurance declaration */
  submitInsuranceDeclaration?: Maybe<SubmitInsuranceDeclarationPayload>,
  /** Submit an invoice */
  submitInvoice?: Maybe<SubmitInvoicePayload>,
  /** Provide consultant working_rights declaration */
  submitWorkingRightsDeclaration?: Maybe<SubmitWorkingRightsDeclarationPayload>,
  /** Submit mutation to unpause a project */
  unpauseProject?: Maybe<UnpauseProjectPayload>,
  /** Update an Education Item on Profile */
  updateEducationItem?: Maybe<UpdateEducationItemPayload>,
  /** Submit mutation to update expert */
  updateExpert?: Maybe<UpdateExpertPayload>,
  /** Submit mutation to update an expert's availability, saved to user_expert_availability table */
  updateExpertAvailability?: Maybe<UpdateExpertAvailabilityPayload>,
  /** Submit mutation to update an expert's business details */
  updateExpertBusinessDetails?: Maybe<UpdateExpertBusinessDetailsPayload>,
  /** Submit mutation to update an expert's contact details */
  updateExpertContactDetails?: Maybe<UpdateExpertContactDetailsPayload>,
  /** Update the insurance settings for an expert */
  updateExpertInsuranceDeclaration?: Maybe<UpdateExpertInsuranceDeclarationPayload>,
  /** Update an expert's payment information */
  updateExpertPaymentInformation?: Maybe<UpdateExpertPaymentInformationPayload>,
  /** Update the profile visibility of an expert */
  updateExpertProfilePrivacy?: Maybe<UpdateExpertProfilePrivacyPayload>,
  /** Updates the rate ranges for an expert */
  updateExpertRates?: Maybe<UpdateExpertRatesPayload>,
  /** Submit mutation to update expert */
  updateExpertTaxSettings?: Maybe<UpdateExpertTaxSettingsPayload>,
  /** Update an Organisation's details */
  updateOrganisationDetails?: Maybe<UpdateOrganisationDetailsPayload>,
  /** update password */
  updatePassword?: Maybe<UpdatePasswordPayload>,
  /** Submit mutation to update profile */
  updateProfile?: Maybe<UpdateProfilePayload>,
  /** Submit mutation to edit a project */
  updateProject?: Maybe<UpdateProjectPayload>,
  /** Update skills on expert profile */
  updateSkills?: Maybe<UpdateSkillsPayload>,
  /** Update a work item on an Expert profile */
  updateWorkItem?: Maybe<UpdateWorkItemPayload>,
};


/** Mutations */
export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput
};


/** Mutations */
export type MutationAcceptOrganisationInvitationArgs = {
  input: AcceptOrganisationInvitationInput
};


/** Mutations */
export type MutationActivateProjectArgs = {
  input: ActivateProjectInput
};


/** Mutations */
export type MutationAddApplicationExperienceArgs = {
  input: AddApplicationExperienceInput
};


/** Mutations */
export type MutationAddApplicationViewedInteractionArgs = {
  input: AddApplicationViewedInteractionInput
};


/** Mutations */
export type MutationAddAvailabilityEventArgs = {
  input: AddAvailabilityEventInput
};


/** Mutations */
export type MutationAddExpertBankAccountArgs = {
  input: AddExpertBankAccountInput
};


/** Mutations */
export type MutationAdminInviteToProjectArgs = {
  input: AdminInviteToProjectInput
};


/** Mutations */
export type MutationApproveContractOfferArgs = {
  input: ApproveContractOfferInput
};


/** Mutations */
export type MutationCancelProjectArgs = {
  input: CancelProjectInput
};


/** Mutations */
export type MutationCreateEducationItemArgs = {
  input: CreateEducationItemInput
};


/** Mutations */
export type MutationCreateFavouriteArgs = {
  input: CreateFavouriteInput
};


/** Mutations */
export type MutationCreateMessageArgs = {
  input: CreateMessageInput
};


/** Mutations */
export type MutationCreateOfferArgs = {
  input: CreateOfferInput
};


/** Mutations */
export type MutationCreateOrganisationInvitationArgs = {
  input: CreateOrganisationInvitationInput
};


/** Mutations */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput
};


/** Mutations */
export type MutationCreateProjectBookmarkArgs = {
  input: CreateProjectBookmarkInput
};


/** Mutations */
export type MutationCreateWorkItemArgs = {
  input: CreateWorkItemInput
};


/** Mutations */
export type MutationDeclineExpertApplicationArgs = {
  input: DeclineExpertApplicationInput
};


/** Mutations */
export type MutationDeleteEducationItemArgs = {
  input: DeleteEducationItemInput
};


/** Mutations */
export type MutationDeleteExpertBankAccountArgs = {
  input: DeleteExpertBankAccountInput
};


/** Mutations */
export type MutationDeleteWorkItemArgs = {
  input: DeleteWorkItemInput
};


/** Mutations */
export type MutationEditTimesheetArgs = {
  input: EditTimesheetInput
};


/** Mutations */
export type MutationInviteExpertToInterviewArgs = {
  input: InviteExpertToInterviewInput
};


/** Mutations */
export type MutationInviteToProjectArgs = {
  input: InviteToProjectInput
};


/** Mutations */
export type MutationModifyOfferArgs = {
  input: ModifyOfferInput
};


/** Mutations */
export type MutationOnholdProjectArgs = {
  input: OnholdProjectInput
};


/** Mutations */
export type MutationOrganisationInvitationCreateAccountArgs = {
  input: OrganisationInvitationCreateAccountInput
};


/** Mutations */
export type MutationPauseProjectArgs = {
  input: PauseProjectInput
};


/** Mutations */
export type MutationPublishProjectArgs = {
  input: PublishProjectInput
};


/** Mutations */
export type MutationRemoveFavouriteArgs = {
  input: RemoveFavouriteInput
};


/** Mutations */
export type MutationRemoveProjectBookmarkArgs = {
  input: RemoveProjectBookmarkInput
};


/** Mutations */
export type MutationRemoveSavedBookmarkArgs = {
  input: RemoveSavedBookmarkInput
};


/** Mutations */
export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput
};


/** Mutations */
export type MutationResendOrganisationInvitationArgs = {
  input: ResendOrganisationInvitationInput
};


/** Mutations */
export type MutationReviewTimesheetArgs = {
  input: ReviewTimesheetInput
};


/** Mutations */
export type MutationReviewTimesheetAnonymouslyArgs = {
  input: ReviewTimesheetAnonymouslyInput
};


/** Mutations */
export type MutationSubmitApplicationArgs = {
  input: SubmitApplicationInput
};


/** Mutations */
export type MutationSubmitDeclineInvitationArgs = {
  input: SubmitDeclineInvitationInput
};


/** Mutations */
export type MutationSubmitExpertApplicationArgs = {
  input: SubmitExpertApplicationInput
};


/** Mutations */
export type MutationSubmitInsuranceDeclarationArgs = {
  input: SubmitInsuranceDeclarationInput
};


/** Mutations */
export type MutationSubmitInvoiceArgs = {
  input: SubmitInvoiceInput
};


/** Mutations */
export type MutationSubmitWorkingRightsDeclarationArgs = {
  input: SubmitWorkingRightsDeclarationInput
};


/** Mutations */
export type MutationUnpauseProjectArgs = {
  input: UnpauseProjectInput
};


/** Mutations */
export type MutationUpdateEducationItemArgs = {
  input: UpdateEducationItemInput
};


/** Mutations */
export type MutationUpdateExpertArgs = {
  input: UpdateExpertInput
};


/** Mutations */
export type MutationUpdateExpertAvailabilityArgs = {
  input: UpdateExpertAvailabilityInput
};


/** Mutations */
export type MutationUpdateExpertBusinessDetailsArgs = {
  input: UpdateExpertBusinessDetailsInput
};


/** Mutations */
export type MutationUpdateExpertContactDetailsArgs = {
  input: UpdateExpertContactDetailsInput
};


/** Mutations */
export type MutationUpdateExpertInsuranceDeclarationArgs = {
  input: UpdateExpertInsuranceDeclarationInput
};


/** Mutations */
export type MutationUpdateExpertPaymentInformationArgs = {
  input: UpdateExpertPaymentInformationInput
};


/** Mutations */
export type MutationUpdateExpertProfilePrivacyArgs = {
  input: UpdateExpertProfilePrivacyInput
};


/** Mutations */
export type MutationUpdateExpertRatesArgs = {
  input: UpdateExpertRatesInput
};


/** Mutations */
export type MutationUpdateExpertTaxSettingsArgs = {
  input: UpdateExpertTaxSettingsInput
};


/** Mutations */
export type MutationUpdateOrganisationDetailsArgs = {
  input: UpdateOrganisationDetailsInput
};


/** Mutations */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput
};


/** Mutations */
export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput
};


/** Mutations */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput
};


/** Mutations */
export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput
};


/** Mutations */
export type MutationUpdateWorkItemArgs = {
  input: UpdateWorkItemInput
};


export type Node = {
  /** The id of the object. */
  id: Scalars['ID'],
};

export type OnholdProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type OnholdProjectPayload = {
   __typename?: 'OnholdProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export enum OperatingType {
  IndependentExpert = 'INDEPENDENT_EXPERT',
  MemberOfFirm = 'MEMBER_OF_FIRM'
}

export type Organisation = Node & {
   __typename?: 'Organisation',
  commission?: Maybe<Scalars['Float']>,
  companySize?: Maybe<Scalars['String']>,
  contractingCompany?: Maybe<Scalars['String']>,
  crn?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['HtmlRichText']>,
  /** Number of business days to payment to expert */
  expertPaymentTermDays?: Maybe<Scalars['Int']>,
  hasExplore?: Maybe<Scalars['Boolean']>,
  hasFms?: Maybe<Scalars['Boolean']>,
  hasMarketplace?: Maybe<Scalars['Boolean']>,
  hasPrivateCloud?: Maybe<Scalars['Boolean']>,
  /** Checks if organisation has an enterprise rate card product */
  hasRateCard?: Maybe<Scalars['Boolean']>,
  hasWhitelabel?: Maybe<Scalars['Boolean']>,
  /** The ID of an object */
  id: Scalars['ID'],
  industry?: Maybe<Industry>,
  /** Checks to see if timesheet is required */
  isTimesheetRequired?: Maybe<Scalars['Boolean']>,
  location?: Maybe<LegacyLocation>,
  name: Scalars['String'],
  organisationDomains?: Maybe<Array<Maybe<OrganisationDomain>>>,
  /** Number of business days to payment */
  paymentTermDays?: Maybe<Scalars['Int']>,
  privateTalentTermsAndConditions?: Maybe<Scalars['String']>,
  /** The rate card roles associated with an organisation */
  rateCardRoles?: Maybe<Array<Maybe<RateCardRole>>>,
  ssoConfig?: Maybe<SsoConfig>,
  url?: Maybe<Scalars['String']>,
  usesOneRatePricingModel?: Maybe<Scalars['Boolean']>,
  /** URL for the white labelling image */
  whitelabelImage?: Maybe<Scalars['String']>,
};

export type OrganisationConnection = {
   __typename?: 'OrganisationConnection',
  edges?: Maybe<Array<Maybe<OrganisationEdge>>>,
  pageInfo: PageInfo,
};

export type OrganisationDomain = Node & {
   __typename?: 'OrganisationDomain',
  /** The ID of an object */
  id: Scalars['ID'],
  insertedAt?: Maybe<Scalars['NaiveDateTime']>,
  matchSignup?: Maybe<Scalars['Boolean']>,
  regex?: Maybe<Scalars['String']>,
  updatedAt?: Maybe<Scalars['NaiveDateTime']>,
};

export type OrganisationEdge = {
   __typename?: 'OrganisationEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Organisation>,
};

export type OrganisationInvitation = Node & {
   __typename?: 'OrganisationInvitation',
  acceptedAt?: Maybe<Scalars['NaiveDateTime']>,
  code?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  expiresAt?: Maybe<Scalars['NaiveDateTime']>,
  firstName?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  lastName?: Maybe<Scalars['String']>,
  organisation?: Maybe<Organisation>,
  recipient?: Maybe<Contact>,
  status?: Maybe<InvitationMessageStatus>,
  updatedAt?: Maybe<Scalars['NaiveDateTime']>,
};

export type OrganisationInvitationConnection = {
   __typename?: 'OrganisationInvitationConnection',
  edges?: Maybe<Array<Maybe<OrganisationInvitationEdge>>>,
  pageInfo: PageInfo,
};

export type OrganisationInvitationCreateAccountInput = {
  clientMutationId: Scalars['String'],
  code: Scalars['String'],
  email: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  password: Scalars['String'],
};

export type OrganisationInvitationCreateAccountPayload = {
   __typename?: 'OrganisationInvitationCreateAccountPayload',
  clientMutationId: Scalars['String'],
  code?: Maybe<Scalars['String']>,
};

export type OrganisationInvitationEdge = {
   __typename?: 'OrganisationInvitationEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<OrganisationInvitation>,
};

export type OrganisationLegalDocumentation = Node & {
   __typename?: 'OrganisationLegalDocumentation',
  document?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  insertedAt?: Maybe<Scalars['NaiveDateTime']>,
  type?: Maybe<Scalars['String']>,
};

export enum OrganisationRole {
  Admin = 'ADMIN',
  Limited = 'LIMITED',
  Member = 'MEMBER'
}

export type PageInfo = {
   __typename?: 'PageInfo',
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>,
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'],
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'],
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>,
};

export type PauseProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type PauseProjectPayload = {
   __typename?: 'PauseProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export type PaymentInformationV2 = {
   __typename?: 'PaymentInformationV2',
  abn?: Maybe<Scalars['String']>,
  acn?: Maybe<Scalars['String']>,
  /** Expert Australian bank account */
  ausBankAccount?: Maybe<BankAccountAus>,
  ausResident?: Maybe<Scalars['Boolean']>,
  bankAccountType?: Maybe<BankAccountType>,
  gstRegistered?: Maybe<Scalars['Boolean']>,
  /** Whether or not consultant has a valid ACN */
  hasAcn?: Maybe<Scalars['Boolean']>,
  /** Expert insurance information */
  insuranceInformation?: Maybe<InsuranceInformation>,
  /** Expert International bank account */
  internationalBankAccount?: Maybe<BankAccountInternational>,
  isLegallyAuthorised?: Maybe<Scalars['Boolean']>,
  operatingType?: Maybe<ConsultantBusinessType>,
  paypalEmail?: Maybe<Scalars['String']>,
  registeredBusinessName?: Maybe<Scalars['String']>,
  residencyStatus?: Maybe<ResidencyStatusType>,
  residencyStatusOther?: Maybe<Scalars['String']>,
  /** Expert US bank account */
  usBankAccount?: Maybe<BankAccountUs>,
};

export type PaymentInvoice = {
   __typename?: 'PaymentInvoice',
  clientName?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  customStatusExplanation?: Maybe<Scalars['String']>,
  dateCreated?: Maybe<Scalars['NaiveDateTime']>,
  dateEnd?: Maybe<Scalars['NaiveDateTime']>,
  dateStart?: Maybe<Scalars['NaiveDateTime']>,
  dateStatusUpdated?: Maybe<Scalars['NaiveDateTime']>,
  dateTimesheetReviewed?: Maybe<Scalars['NaiveDateTime']>,
  deliverableGstTotal?: Maybe<Scalars['Decimal']>,
  deliverables?: Maybe<Array<Maybe<Deliverable>>>,
  deliverableSubtotal?: Maybe<Scalars['Decimal']>,
  deliverableTotal?: Maybe<Scalars['Decimal']>,
  expectedDatePaid?: Maybe<Scalars['NaiveDateTime']>,
  expenseGstTotal?: Maybe<Scalars['Decimal']>,
  expenses?: Maybe<Array<Maybe<Expense>>>,
  expenseSubtotal?: Maybe<Scalars['Decimal']>,
  expenseTotal?: Maybe<Scalars['Decimal']>,
  expert?: Maybe<User>,
  expertBusinessName?: Maybe<Scalars['String']>,
  expertName?: Maybe<Scalars['String']>,
  finalInvoice?: Maybe<Scalars['Boolean']>,
  gstRegistered?: Maybe<Scalars['Boolean']>,
  gstTotal?: Maybe<Scalars['Decimal']>,
  hasAcn?: Maybe<Scalars['Boolean']>,
  id: Scalars['ID'],
  invoiceAs?: Maybe<Scalars['String']>,
  isOverdue?: Maybe<Scalars['Boolean']>,
  notes?: Maybe<Scalars['String']>,
  organisationName?: Maybe<Scalars['String']>,
  project?: Maybe<ProjectV2>,
  rate?: Maybe<Scalars['Decimal']>,
  remoteId?: Maybe<Scalars['String']>,
  status?: Maybe<InvoiceStatus>,
  subtotal?: Maybe<Scalars['Decimal']>,
  timesheetGstTotal?: Maybe<Scalars['Decimal']>,
  timesheetQuantity?: Maybe<Scalars['Decimal']>,
  timesheetReviewer?: Maybe<Scalars['String']>,
  timesheets?: Maybe<Array<Maybe<Timesheet>>>,
  timesheetSubtotal?: Maybe<Scalars['Decimal']>,
  timesheetTotal?: Maybe<Scalars['Decimal']>,
  total?: Maybe<Scalars['Decimal']>,
};

export type PaymentInvoiceConnection = {
   __typename?: 'PaymentInvoiceConnection',
  edges?: Maybe<Array<Maybe<PaymentInvoiceEdge>>>,
  pageInfo: PageInfo,
};

export type PaymentInvoiceEdge = {
   __typename?: 'PaymentInvoiceEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<PaymentInvoice>,
};

export type PostedProject = {
   __typename?: 'PostedProject',
  code?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
};

export enum Privacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Profile = Node & {
   __typename?: 'Profile',
  /** 
 * The availability status of the user.
   * 
   * Returns an `EventType` for an expert.
   * 
   * Returns `null` for a client.
 */
  availabilityStatus?: Maybe<EventType>,
  code: Scalars['String'],
  completionStatus?: Maybe<Scalars['Int']>,
  educationItems?: Maybe<Array<EducationItem>>,
  hash?: Maybe<Scalars['String']>,
  headline?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  industries?: Maybe<Array<Industry>>,
  isExternalPublic?: Maybe<Scalars['Boolean']>,
  private?: Maybe<Scalars['Boolean']>,
  profileComplete?: Maybe<Scalars['Boolean']>,
  profileStep?: Maybe<Scalars['String']>,
  projectCount?: Maybe<Scalars['Int']>,
  published?: Maybe<Scalars['Boolean']>,
  skills?: Maybe<Array<Skill>>,
  summary?: Maybe<Scalars['HtmlRichText']>,
  tier?: Maybe<Scalars['Int']>,
  user: User,
  /** 
 * Organisation membership based on current user.
   * 
   * The original intent of this field is to allow clients to determine if
   * someone with a profile is in their private cloud. This is plural as clients
   * might be in multiple private clouds.
   * 
   * Currently only clients can see the orgs they share with this consultant.
 */
  viewerPrivateTalentOrganisations: Array<Organisation>,
  workItems?: Maybe<Array<WorkItem>>,
};

export type ProfilePicture = {
   __typename?: 'ProfilePicture',
  height: Scalars['Int'],
  source: Scalars['String'],
  width: Scalars['Int'],
};

/** Available profile picture sizes */
export enum ProfilePictureSize {
  Large = 'LARGE',
  Normal = 'NORMAL'
}

export type ProfileV2 = Node & {
   __typename?: 'ProfileV2',
  availability?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  educationItems?: Maybe<Array<EducationItem>>,
  hash?: Maybe<Scalars['String']>,
  headline?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  /** 
 * A list of industries the Expert has worked in.
   * NOTE: This is now considered legacy.
   * With the MM profile builder we will be capturing industry information on work history items.
   * This industry info is used for matching purposes, and is read only on profiles and profile builder.
 */
  industries?: Maybe<Array<Industry>>,
  insuranceDeclarationDate?: Maybe<Scalars['Date']>,
  isExternalPublic?: Maybe<Scalars['Boolean']>,
  isInternalPublic?: Maybe<Scalars['Boolean']>,
  linkedinUrl?: Maybe<Scalars['String']>,
  maxDailyRate?: Maybe<Scalars['Decimal']>,
  maxHourlyRate?: Maybe<Scalars['Decimal']>,
  minDailyRate?: Maybe<Scalars['Decimal']>,
  minHourlyRate?: Maybe<Scalars['Decimal']>,
  skills?: Maybe<Array<Skill>>,
  summary?: Maybe<Scalars['String']>,
  vettedIntoMarketplace?: Maybe<Scalars['Boolean']>,
  websiteUrl?: Maybe<Scalars['String']>,
  workingRights?: Maybe<ExpertWorkingRightsV2>,
  workingRightsDeclarationDate?: Maybe<Scalars['NaiveDateTime']>,
};

export type Project = Node & Projectable & {
   __typename?: 'Project',
  appliedUsers?: Maybe<Array<User>>,
  budgetCurrency?: Maybe<Scalars['String']>,
  budgetMax?: Maybe<Scalars['Float']>,
  budgetMin?: Maybe<Scalars['Float']>,
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>,
  code?: Maybe<Scalars['String']>,
  companyName?: Maybe<Scalars['String']>,
  companyType?: Maybe<Scalars['String']>,
  contracts?: Maybe<ContractConnection>,
  created?: Maybe<Scalars['NaiveDateTime']>,
  createdBy?: Maybe<User>,
  dateCompleted?: Maybe<Scalars['String']>,
  dateCreated?: Maybe<Scalars['String']>,
  dateEnd?: Maybe<Scalars['String']>,
  datePublished?: Maybe<Scalars['String']>,
  dateStart?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['String']>,
  earn?: Maybe<Scalars['String']>,
  enterpriseRateCardRole?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  idealStart?: Maybe<Scalars['String']>,
  industry?: Maybe<Scalars['String']>,
  intensity?: Maybe<Scalars['String']>,
  invitedUsers?: Maybe<Array<User>>,
  locationType?: Maybe<Scalars['String']>,
  organisations?: Maybe<Array<Organisation>>,
  postedDate?: Maybe<Scalars['String']>,
  postedDateUtc?: Maybe<Scalars['String']>,
  privacy: Privacy,
  progressOfProject?: Maybe<Scalars['String']>,
  projectLocation?: Maybe<Scalars['String']>,
  rateUnit?: Maybe<Scalars['String']>,
  startAsap?: Maybe<Scalars['Boolean']>,
  status?: Maybe<Status>,
  statusOfProject?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  unlisted?: Maybe<Scalars['Boolean']>,
  updated?: Maybe<Scalars['NaiveDateTime']>,
  viewerHasBookmarked: Scalars['Boolean'],
};


export type ProjectContractsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type Projectable = {
  budgetCurrency?: Maybe<Scalars['String']>,
  budgetMax?: Maybe<Scalars['Float']>,
  budgetMin?: Maybe<Scalars['Float']>,
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>,
  code?: Maybe<Scalars['String']>,
  companyType?: Maybe<Scalars['String']>,
  created?: Maybe<Scalars['NaiveDateTime']>,
  datePublished?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['String']>,
  earn?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  idealStart?: Maybe<Scalars['String']>,
  industry?: Maybe<Scalars['String']>,
  intensity?: Maybe<Scalars['String']>,
  locationType?: Maybe<Scalars['String']>,
  postedDate?: Maybe<Scalars['String']>,
  progressOfProject?: Maybe<Scalars['String']>,
  projectLocation?: Maybe<Scalars['String']>,
  rateUnit?: Maybe<Scalars['String']>,
  statusOfProject?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  updated?: Maybe<Scalars['NaiveDateTime']>,
  viewerHasBookmarked: Scalars['Boolean'],
};

export enum ProjectAudience {
  DirectOffer = 'DIRECT_OFFER',
  InviteOnly = 'INVITE_ONLY',
  PrivateCloud = 'PRIVATE_CLOUD',
  Public = 'PUBLIC'
}

export type ProjectBriefInput = {
  budgetCurrency?: Maybe<Scalars['String']>,
  budgetMax?: Maybe<Scalars['Float']>,
  budgetMin?: Maybe<Scalars['Float']>,
  businessServices: Array<ServiceInput>,
  customBusinessServices?: Maybe<Array<Scalars['String']>>,
  dateEnd?: Maybe<Scalars['String']>,
  dateStart?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['String']>,
  idealExpertSummary?: Maybe<Scalars['String']>,
  idealExpertTitle?: Maybe<Scalars['String']>,
  industryIds: Array<ServiceInput>,
  intensity?: Maybe<Scalars['String']>,
  isSharedWithMarketplace?: Maybe<Scalars['Boolean']>,
  isSharedWithPrivateCloud?: Maybe<Scalars['Boolean']>,
  locationId?: Maybe<Scalars['ID']>,
  locationType?: Maybe<Scalars['String']>,
  privacy?: Maybe<ProjectPrivacyV2>,
  rateUnit?: Maybe<Scalars['String']>,
  roleId?: Maybe<Scalars['ID']>,
  roleTitleId?: Maybe<Scalars['ID']>,
  showCompanyName?: Maybe<Scalars['Boolean']>,
  startAsap?: Maybe<Scalars['Boolean']>,
  summary?: Maybe<Scalars['String']>,
  title: Scalars['String'],
};

export type ProjectConnection = {
   __typename?: 'ProjectConnection',
  edges?: Maybe<Array<Maybe<ProjectEdge>>>,
  pageInfo: PageInfo,
};

export type ProjectEdge = {
   __typename?: 'ProjectEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Project>,
};

export enum ProjectIsInsuredV2 {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED',
  UnderReview = 'UNDER_REVIEW'
}

export enum ProjectPrivacyV2 {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ProjectStateV2 {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Hired = 'HIRED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  Paused = 'PAUSED'
}

export type ProjectStatus = {
   __typename?: 'ProjectStatus',
  applicationCount?: Maybe<Scalars['Int']>,
  applicationDeclinedCount?: Maybe<Scalars['Int']>,
  expertDeclinedCount?: Maybe<Scalars['Int']>,
  expertStatus?: Maybe<ExpertStatus>,
  expertStatusDate?: Maybe<Scalars['Timestamp']>,
  interviewCount?: Maybe<Scalars['Int']>,
  lifecycleStatus?: Maybe<LifecycleStatus>,
  lifecycleStatusDate?: Maybe<Scalars['Timestamp']>,
  modifier?: Maybe<LifecycleModifier>,
  modifierDate?: Maybe<Scalars['Timestamp']>,
  offerCount?: Maybe<Scalars['Int']>,
};

export type ProjectV2 = Node & {
   __typename?: 'ProjectV2',
  agreedContracts?: Maybe<ContractConnection>,
  applicantCount?: Maybe<Scalars['Int']>,
  /** Applications for this project */
  applications?: Maybe<ApplicationV2Connection>,
  audience?: Maybe<ProjectAudience>,
  budgetCurrency?: Maybe<Scalars['String']>,
  budgetMax?: Maybe<Scalars['Float']>,
  budgetMin?: Maybe<Scalars['Float']>,
  code?: Maybe<Scalars['String']>,
  /** 
 * Resolving company name in here probably needs some more thought. This resolver
   * uses a field on the project table called `showCompanyName` to determine if the
   * project author has opted in to display the name of their company. This is separate
   * from the organisation schema, and revolves around the project. This should be revisited
   * in the future. One option is to make displaying this information permissions based,
   * and another is to expose the `organisation` type on a project in order to know which
   * organisation a project is related to.
 */
  companyName?: Maybe<Scalars['String']>,
  companyType?: Maybe<Scalars['String']>,
  contractingCompany?: Maybe<ContractingCompany>,
  /** Contract terms for the current user (either client or expert) */
  contractTerms?: Maybe<Scalars['String']>,
  createdBy?: Maybe<User>,
  currentContract?: Maybe<Contract>,
  dateCompleted?: Maybe<Scalars['Timestamp']>,
  dateCreated?: Maybe<Scalars['Timestamp']>,
  dateEnd?: Maybe<Scalars['Timestamp']>,
  datePublished?: Maybe<Scalars['Timestamp']>,
  dateStart?: Maybe<Scalars['Timestamp']>,
  dateUpdated?: Maybe<Scalars['Timestamp']>,
  duration?: Maybe<Scalars['String']>,
  earn?: Maybe<Scalars['String']>,
  externalApplicationUrl?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  idealExpertSummary?: Maybe<Scalars['String']>,
  idealExpertTitle?: Maybe<Scalars['String']>,
  industries: Array<Industry>,
  industry?: Maybe<Scalars['String']>,
  industryName?: Maybe<Scalars['String']>,
  intensity?: Maybe<Scalars['String']>,
  invoices?: Maybe<PaymentInvoiceConnection>,
  /** States whether the current user is the project creator */
  isCreator?: Maybe<Scalars['Boolean']>,
  isInsured?: Maybe<ProjectIsInsuredV2>,
  isSharedWithMarketplace?: Maybe<Scalars['Boolean']>,
  isSharedWithPrivateCloud?: Maybe<Scalars['Boolean']>,
  lastInvoice?: Maybe<Invoice>,
  /** Applications that were submitted in the old flow (i.e. saved in the interactions table) */
  legacyApplications?: Maybe<LegacyApplicationV2Connection>,
  location?: Maybe<Scalars['String']>,
  locationDetails?: Maybe<LegacyLocation>,
  locationType?: Maybe<Scalars['String']>,
  offers?: Maybe<ContractConnection>,
  organisations?: Maybe<Array<Organisation>>,
  postedDateUtc?: Maybe<Scalars['Timestamp']>,
  /** 
 * The privacy of the project.
   * 
   * `PRIVATE` for private projects and `PUBLIC` for public projects.
 */
  privacy?: Maybe<ProjectPrivacyV2>,
  progressOfProject?: Maybe<Scalars['String']>,
  /** 
 * Rate card clients have a rate card role associated to their project.
   * See table 'Enterprise Rate Card Project & Enterprise Rate Card Role.'
 */
  rateCardRole?: Maybe<RateCardRole>,
  rateUnit?: Maybe<Scalars['String']>,
  roleTitleId?: Maybe<Scalars['ID']>,
  servicesRequired: Array<BusinessService>,
  showCompanyName?: Maybe<Scalars['Boolean']>,
  startAsap?: Maybe<Scalars['Boolean']>,
  state?: Maybe<ProjectStateV2>,
  /** status from Service.Project.Status */
  status?: Maybe<ProjectStatus>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  unapprovedServicesRequired: Array<BusinessService>,
  unlisted?: Maybe<Scalars['Boolean']>,
  usesOneRatePricingModel?: Maybe<Scalars['Boolean']>,
  viewerContract?: Maybe<Contract>,
  viewerInvitation?: Maybe<ViewerInvitation>,
};


export type ProjectV2AgreedContractsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  shouldGroupByExpert?: Maybe<Scalars['Boolean']>
};


export type ProjectV2ApplicationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ProjectV2InvoicesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ProjectV2LegacyApplicationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ProjectV2OffersArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type ProjectV2Connection = {
   __typename?: 'ProjectV2Connection',
  edges?: Maybe<Array<Maybe<ProjectV2Edge>>>,
  pageInfo: PageInfo,
  totalCount?: Maybe<Scalars['Int']>,
};

export type ProjectV2Edge = {
   __typename?: 'ProjectV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<ProjectV2>,
};

export type PublishProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type PublishProjectPayload = {
   __typename?: 'PublishProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

/** Queries */
export type Query = {
   __typename?: 'Query',
  /** List all bookmarked projects */
  bookmarks?: Maybe<BookmarkConnection>,
  /** List the current users contacts */
  contacts?: Maybe<ContactConnection>,
  /** Lists all disciplines by matching string */
  disciplines?: Maybe<DisciplineConnection>,
  /** Search for Experts using filters */
  experts?: Maybe<SearchConsultantConnection>,
  /** List the user favourites */
  favouriteContacts?: Maybe<ContactConnection>,
  /** Get legal documentation by type */
  legalDocumentation?: Maybe<OrganisationLegalDocumentation>,
  node?: Maybe<Node>,
  /** A User's Professional Profile */
  profile?: Maybe<Profile>,
  /** 
 * List of projects.
   * Filtering by date range requires a user to be logged in
   * and will be limited to projects in organisations for
   * which they are admin.
 */
  projects?: Maybe<ProjectConnection>,
  /** List all search_consultants */
  search?: Maybe<SearchResultConnection>,
  /** List all search_filters */
  searchFilters?: Maybe<SearchFilters>,
  /** Lists all skills by matching string */
  skills?: Maybe<SkillConnection>,
  /** List all threads */
  threads?: Maybe<ThreadConnection>,
  /** 
 * GraphQL 'v2'
   * 
   * A temporary namespace for overlapping, new changes and migrations.
 */
  v2?: Maybe<V2>,
  /** Current User */
  viewer?: Maybe<Viewer>,
};


/** Queries */
export type QueryBookmarksArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


/** Queries */
export type QueryContactsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


/** Queries */
export type QueryDisciplinesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  discipline?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


/** Queries */
export type QueryExpertsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filters?: Maybe<ExpertFilterInput>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


/** Queries */
export type QueryFavouriteContactsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


/** Queries */
export type QueryLegalDocumentationArgs = {
  type?: Maybe<Scalars['String']>
};


/** Queries */
export type QueryNodeArgs = {
  id: Scalars['ID']
};


/** Queries */
export type QueryProfileArgs = {
  code?: Maybe<Scalars['String']>
};


/** Queries */
export type QueryProjectsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  dateRange?: Maybe<DateRangeInput>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  profileSlug?: Maybe<Scalars['String']>
};


/** Queries */
export type QuerySearchArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  query?: Maybe<SearchQueryInput>
};


/** Queries */
export type QuerySearchFiltersArgs = {
  query?: Maybe<SearchQueryInput>
};


/** Queries */
export type QuerySkillsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  skill?: Maybe<Scalars['String']>
};


/** Queries */
export type QueryThreadsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type QueryOptions = {
  advancedSearch?: Maybe<Scalars['Boolean']>,
};

export type RateCardRole = Node & {
   __typename?: 'RateCardRole',
  /** The ID of an object */
  id: Scalars['ID'],
  maximumRate?: Maybe<Scalars['Decimal']>,
  minimumRate?: Maybe<Scalars['Decimal']>,
  name?: Maybe<Scalars['String']>,
};

export enum RateUnit {
  Day = 'DAY',
  Fixed = 'FIXED',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type RatingAndReview = Node & {
   __typename?: 'RatingAndReview',
  feedbackSkillRating: Array<FeedbackSkillRating>,
  feedbackUserPublic?: Maybe<FeedbackUserPublic>,
  hash?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  project: Project,
};

export type RemoveFavouriteInput = {
  clientMutationId: Scalars['String'],
  userId: Scalars['ID'],
};

export type RemoveFavouritePayload = {
   __typename?: 'RemoveFavouritePayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<User>,
};

export type RemoveProjectBookmarkInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type RemoveProjectBookmarkPayload = {
   __typename?: 'RemoveProjectBookmarkPayload',
  clientMutationId: Scalars['String'],
  searchProject?: Maybe<SearchProject>,
};

export type RemoveSavedBookmarkInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type RemoveSavedBookmarkPayload = {
   __typename?: 'RemoveSavedBookmarkPayload',
  bookmark?: Maybe<BookmarkEdge>,
  clientMutationId: Scalars['String'],
};

export type RequestPasswordResetInput = {
  clientMutationId: Scalars['String'],
  email: Scalars['String'],
};

export type RequestPasswordResetPayload = {
   __typename?: 'RequestPasswordResetPayload',
  clientMutationId: Scalars['String'],
  confirmation?: Maybe<Scalars['Boolean']>,
  hasSso?: Maybe<Scalars['Boolean']>,
  requireSso?: Maybe<Scalars['Boolean']>,
};

export type ResendOrganisationInvitationInput = {
  clientMutationId: Scalars['String'],
  code: Scalars['String'],
};

export type ResendOrganisationInvitationPayload = {
   __typename?: 'ResendOrganisationInvitationPayload',
  clientMutationId: Scalars['String'],
  organisationInvitation?: Maybe<OrganisationInvitation>,
};

export enum ResidencyStatusType {
  AusCitizen = 'AUS_CITIZEN',
  AusResident = 'AUS_RESIDENT',
  NzCitizen = 'NZ_CITIZEN',
  Other = 'OTHER'
}

export type ReviewTimesheetAnonymouslyInput = {
  clientMutationId: Scalars['String'],
  /** invoice code */
  code: Scalars['String'],
  email: Scalars['String'],
  /** invoice status */
  status: TimesheetReviewStatus,
  /** invoice HMAC tag used for authentication */
  tag: Scalars['String'],
};

export type ReviewTimesheetAnonymouslyPayload = {
   __typename?: 'ReviewTimesheetAnonymouslyPayload',
  alreadyReviewed?: Maybe<Scalars['Boolean']>,
  clientMutationId: Scalars['String'],
};

export type ReviewTimesheetInput = {
  clientMutationId: Scalars['String'],
  /** invoice code */
  code: Scalars['String'],
  /** invoice status explanation */
  customStatusExplanation?: Maybe<Scalars['String']>,
  /** invoice status */
  status: TimesheetReviewStatus,
  /** fullname of the timesheet reviewer */
  timesheetReviewer?: Maybe<Scalars['String']>,
};

export type ReviewTimesheetPayload = {
   __typename?: 'ReviewTimesheetPayload',
  clientMutationId: Scalars['String'],
  paymentInvoice?: Maybe<PaymentInvoice>,
};

export enum Role {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Consultant = 'CONSULTANT',
  SuperAdmin = 'SUPER_ADMIN'
}

export type RoleTitle = Node & {
   __typename?: 'RoleTitle',
  /** The ID of an object */
  id: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
};

export type RoleTitleConnection = {
   __typename?: 'RoleTitleConnection',
  edges?: Maybe<Array<Maybe<RoleTitleEdge>>>,
  pageInfo: PageInfo,
};

export type RoleTitleEdge = {
   __typename?: 'RoleTitleEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<RoleTitle>,
};

export type SearchConsultant = Node & {
   __typename?: 'SearchConsultant',
  availability?: Maybe<AvailabilityV2>,
  backOffice?: Maybe<BackOffice>,
  currency?: Maybe<Scalars['String']>,
  currentAvailability?: Maybe<Scalars['String']>,
  currentProject?: Maybe<Project>,
  dailyRate?: Maybe<Scalars['String']>,
  dateAvailable?: Maybe<Scalars['Date']>,
  highlights?: Maybe<SearchExpertHighlights>,
  hourlyRate?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  name: Scalars['String'],
  organisations?: Maybe<Array<SearchOrganisation>>,
  profile: SearchConsultantProfile,
  profilePicture?: Maybe<ProfilePicture>,
  profileUrl?: Maybe<Scalars['String']>,
  projects?: Maybe<ProjectConnection>,
  rating?: Maybe<Scalars['Float']>,
  skills?: Maybe<Array<Scalars['String']>>,
};


export type SearchConsultantProjectsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type SearchConsultantConnection = {
   __typename?: 'SearchConsultantConnection',
  edges?: Maybe<Array<Maybe<SearchConsultantEdge>>>,
  pageInfo: PageInfo,
  totalCount: Scalars['Int'],
};

export type SearchConsultantEdge = {
   __typename?: 'SearchConsultantEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<SearchConsultant>,
};

export type SearchConsultantProfile = {
   __typename?: 'SearchConsultantProfile',
  code?: Maybe<Scalars['String']>,
  discipline?: Maybe<Scalars['String']>,
  headline?: Maybe<Scalars['String']>,
  location?: Maybe<SearchLocation>,
  maxDailyRate?: Maybe<Scalars['String']>,
  minDailyRate?: Maybe<Scalars['String']>,
  organisationNames?: Maybe<Array<Scalars['String']>>,
  projectCount?: Maybe<Scalars['Int']>,
  summary?: Maybe<Scalars['String']>,
  workItems?: Maybe<Array<SearchWorkItem>>,
};

export type SearchExpertHighlights = {
   __typename?: 'SearchExpertHighlights',
  industries?: Maybe<Array<Scalars['String']>>,
  organisations?: Maybe<Array<Scalars['String']>>,
  roleTitles?: Maybe<Array<Scalars['String']>>,
  skills?: Maybe<Array<Scalars['String']>>,
};

export type SearchFilter = {
   __typename?: 'SearchFilter',
  count?: Maybe<Scalars['Int']>,
  /** Resolving to different field name to prevent conflicts on id */
  filterId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  subCategories?: Maybe<Array<Maybe<SearchFilter>>>,
};

export type SearchFilterInput = {
  category?: Maybe<Scalars['String']>,
  filterId?: Maybe<Scalars['String']>,
};

export type SearchFilters = {
   __typename?: 'SearchFilters',
  availabilities?: Maybe<Array<Maybe<SearchFilter>>>,
  availabilityCapacity?: Maybe<Array<Maybe<SearchFilter>>>,
  availabilityDates?: Maybe<Array<Maybe<SearchFilter>>>,
  businessServices?: Maybe<Array<Maybe<SearchFilter>>>,
  cities?: Maybe<Array<Maybe<SearchFilter>>>,
  countries?: Maybe<Array<Maybe<SearchFilter>>>,
  locationTypes?: Maybe<Array<Maybe<SearchFilter>>>,
  newAvailability?: Maybe<Array<Maybe<SearchFilter>>>,
  organisations?: Maybe<Array<Maybe<SearchFilter>>>,
};

export type SearchLocation = {
   __typename?: 'SearchLocation',
  city?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  subdivision?: Maybe<Scalars['String']>,
};

export type SearchOrganisation = {
   __typename?: 'SearchOrganisation',
  name?: Maybe<Scalars['String']>,
  /** Resolving to different field name to prevent conflicts on id */
  orgId?: Maybe<Scalars['String']>,
};

export type SearchProject = Node & Projectable & {
   __typename?: 'SearchProject',
  application?: Maybe<ApplicationV2>,
  budgetCurrency?: Maybe<Scalars['String']>,
  budgetMax?: Maybe<Scalars['Float']>,
  budgetMin?: Maybe<Scalars['Float']>,
  businessServices?: Maybe<Array<Maybe<Scalars['String']>>>,
  code?: Maybe<Scalars['String']>,
  companyName?: Maybe<Scalars['String']>,
  companyType?: Maybe<Scalars['String']>,
  created?: Maybe<Scalars['NaiveDateTime']>,
  dateEnd?: Maybe<Scalars['NaiveDateTime']>,
  datePublished?: Maybe<Scalars['String']>,
  dateStart?: Maybe<Scalars['NaiveDateTime']>,
  duration?: Maybe<Scalars['String']>,
  earn?: Maybe<Scalars['String']>,
  /** The ID of an object */
  id: Scalars['ID'],
  idealExpertSummary?: Maybe<Scalars['String']>,
  idealExpertTitle?: Maybe<Scalars['String']>,
  idealStart?: Maybe<Scalars['String']>,
  industries?: Maybe<Array<Maybe<Scalars['String']>>>,
  industry?: Maybe<Scalars['String']>,
  intensity?: Maybe<Scalars['String']>,
  locationType?: Maybe<Scalars['String']>,
  organisations?: Maybe<Array<SearchOrganisation>>,
  postedDate?: Maybe<Scalars['String']>,
  postedDateUtc?: Maybe<Scalars['Timestamp']>,
  progressOfProject?: Maybe<Scalars['String']>,
  projectLocation?: Maybe<Scalars['String']>,
  rateUnit?: Maybe<Scalars['String']>,
  statusOfProject?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  updated?: Maybe<Scalars['NaiveDateTime']>,
  viewerHasBookmarked: Scalars['Boolean'],
};

export type SearchQueryInput = {
  categorySearch?: Maybe<Array<Maybe<SearchFilterInput>>>,
  filters?: Maybe<Array<Maybe<SearchFilterInput>>>,
  options?: Maybe<QueryOptions>,
  searchWord?: Maybe<Array<Maybe<Scalars['String']>>>,
  type?: Maybe<SearchQueryKey>,
};

export enum SearchQueryKey {
  Consultant = 'CONSULTANT',
  Project = 'PROJECT'
}

/** A search result */
export type SearchResult = SearchConsultant | SearchProject;

export type SearchResultConnection = {
   __typename?: 'SearchResultConnection',
  edges?: Maybe<Array<Maybe<SearchResultEdge>>>,
  pageInfo: PageInfo,
  totalCount: Scalars['Int'],
};

export type SearchResultEdge = {
   __typename?: 'SearchResultEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<SearchResult>,
};

export type SearchWorkItem = {
   __typename?: 'SearchWorkItem',
  organisation?: Maybe<SearchOrganisation>,
  roleTitle: Scalars['String'],
  summary: Scalars['String'],
};

export type ServiceInput = {
  id: Scalars['ID'],
};

export type Skill = Node & {
   __typename?: 'Skill',
  /** The ID of an object */
  id: Scalars['ID'],
  skill: Scalars['String'],
};

export type SkillConnection = {
   __typename?: 'SkillConnection',
  edges?: Maybe<Array<Maybe<SkillEdge>>>,
  pageInfo: PageInfo,
};

export type SkillEdge = {
   __typename?: 'SkillEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Skill>,
};

export type SkillInput = {
  id?: Maybe<Scalars['ID']>,
};

export type SsoConfig = Node & {
   __typename?: 'SsoConfig',
  /** The ID of an object */
  id: Scalars['ID'],
  requireSso?: Maybe<Scalars['Boolean']>,
};

export enum Status {
  Active = 'ACTIVE',
  Applications = 'APPLICATIONS',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING'
}

export enum StatusOptions {
  Inactive = 'INACTIVE',
  Active = 'ACTIVE'
}

export type SubmitApplicationExperienceV2 = {
  description?: Maybe<Scalars['String']>,
  projectId?: Maybe<Scalars['ID']>,
  workHistoryId?: Maybe<Scalars['ID']>,
};

export type SubmitApplicationInput = {
  /** The project id of the application being applied to */
  applicationProjectId: Scalars['ID'],
  /** The introductory statement the applicant wishes to offer */
  applicationStatement?: Maybe<Scalars['String']>,
  /** Status of the application to save */
  applicationStatus: ApplicationStatusV2,
  /** The budget the applicant wishes to propose */
  budgetSuggestion?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  /** The ideal start date the applicant wishes to propose */
  dateStartSuggestion?: Maybe<Scalars['String']>,
  /** The expert's proposed earning rate for this project */
  proposedRate?: Maybe<Scalars['Decimal']>,
  /** The unit of the rate e.g. per day */
  proposedRateUnit?: Maybe<RateUnit>,
  /** The chosen list of application experiences to include with the application */
  selectedExperiences: Array<SubmitApplicationExperienceV2>,
};

export type SubmitApplicationPayload = {
   __typename?: 'SubmitApplicationPayload',
  application?: Maybe<ApplicationV2>,
  clientMutationId: Scalars['String'],
};

export type SubmitDeclineInvitationInput = {
  clientMutationId: Scalars['String'],
  declineAdditionalComments?: Maybe<Scalars['String']>,
  declineReason: Scalars['String'],
  projectCode: Scalars['String'],
};

export type SubmitDeclineInvitationPayload = {
   __typename?: 'SubmitDeclineInvitationPayload',
  clientMutationId: Scalars['String'],
  declinedInvitation?: Maybe<DeclinedInvitation>,
};

export type SubmitExpertApplicationInput = {
  applicationStep?: Maybe<Scalars['String']>,
  availability?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  expert?: Maybe<Expert>,
  linkedinUrl?: Maybe<Scalars['String']>,
  websiteUrl?: Maybe<Scalars['String']>,
};

export type SubmitExpertApplicationPayload = {
   __typename?: 'SubmitExpertApplicationPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type SubmitInsuranceDeclarationInput = {
  clientMutationId: Scalars['String'],
};

export type SubmitInsuranceDeclarationPayload = {
   __typename?: 'SubmitInsuranceDeclarationPayload',
  clientMutationId: Scalars['String'],
  insuranceDeclarationDate?: Maybe<Scalars['Date']>,
};

export type SubmitInvoiceInput = {
  budgetUnit?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  clientName?: Maybe<Scalars['String']>,
  companyName?: Maybe<Scalars['String']>,
  currency?: Maybe<Scalars['String']>,
  dateEnd: Scalars['NaiveDateTime'],
  dateStart: Scalars['NaiveDateTime'],
  deliverables?: Maybe<Array<Maybe<DeliverableInput>>>,
  expenses?: Maybe<Array<Maybe<ExpenseInput>>>,
  expertPaymentTermDays?: Maybe<Scalars['Int']>,
  finalInvoice?: Maybe<Scalars['Boolean']>,
  invoiceAs?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  projectId: Scalars['ID'],
  projectType?: Maybe<Scalars['String']>,
  rate?: Maybe<Scalars['Decimal']>,
  remoteId?: Maybe<Scalars['String']>,
  timesheets?: Maybe<Array<Maybe<TimesheetInput>>>,
  totalAmount?: Maybe<Scalars['Decimal']>,
};

export type SubmitInvoicePayload = {
   __typename?: 'SubmitInvoicePayload',
  clientMutationId: Scalars['String'],
  paymentInvoice?: Maybe<PaymentInvoice>,
};

export type SubmitWorkingRightsDeclarationInput = {
  clientMutationId: Scalars['String'],
  workingRights?: Maybe<ExpertWorkingRightsV2>,
};

export type SubmitWorkingRightsDeclarationPayload = {
   __typename?: 'SubmitWorkingRightsDeclarationPayload',
  clientMutationId: Scalars['String'],
  workingRights?: Maybe<ExpertWorkingRightsV2>,
  workingRightsDeclarationDate?: Maybe<Scalars['Date']>,
};

export type Thread = Node & {
   __typename?: 'Thread',
  /** The ID of an object */
  id: Scalars['ID'],
  latestMessageTimestamp: Scalars['String'],
  messages?: Maybe<Array<Maybe<Message>>>,
  participants?: Maybe<Array<Maybe<Contact>>>,
  profileCode?: Maybe<Scalars['String']>,
  projectCode: Scalars['String'],
  status?: Maybe<MessageStatus>,
  unread: Scalars['Boolean'],
};

export type ThreadConnection = {
   __typename?: 'ThreadConnection',
  edges?: Maybe<Array<Maybe<ThreadEdge>>>,
  pageInfo: PageInfo,
};

export type ThreadEdge = {
   __typename?: 'ThreadEdge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<Thread>,
};

export type Timesheet = {
   __typename?: 'Timesheet',
  dateStart?: Maybe<Scalars['NaiveDateTime']>,
  note?: Maybe<Scalars['String']>,
  quantity?: Maybe<Scalars['Decimal']>,
};

export type TimesheetInput = {
  dateStart: Scalars['NaiveDateTime'],
  note?: Maybe<Scalars['String']>,
  quantity: Scalars['Decimal'],
};

export enum TimesheetReviewStatus {
  Submitted = 'SUBMITTED',
  TimesheetRejected = 'TIMESHEET_REJECTED'
}


export type UnpauseProjectInput = {
  clientMutationId: Scalars['String'],
  projectId: Scalars['ID'],
};

export type UnpauseProjectPayload = {
   __typename?: 'UnpauseProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export type UpdateEducationItemInput = {
  clientMutationId: Scalars['String'],
  educationItem?: Maybe<EducationItemInput>,
  educationItemId: Scalars['ID'],
};

export type UpdateEducationItemPayload = {
   __typename?: 'UpdateEducationItemPayload',
  clientMutationId: Scalars['String'],
  educationItem?: Maybe<EducationItem>,
};

export type UpdateExpertAvailabilityInput = {
  availability?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  unavailableUntilDate?: Maybe<Scalars['String']>,
};

export type UpdateExpertAvailabilityPayload = {
   __typename?: 'UpdateExpertAvailabilityPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertBusinessDetailsInput = {
  abn?: Maybe<Scalars['String']>,
  acn?: Maybe<Scalars['String']>,
  clientMutationId: Scalars['String'],
  operatingType?: Maybe<OperatingType>,
  registeredBusinessName?: Maybe<Scalars['String']>,
};

export type UpdateExpertBusinessDetailsPayload = {
   __typename?: 'UpdateExpertBusinessDetailsPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertContactDetailsInput = {
  clientMutationId: Scalars['String'],
  phoneMobile?: Maybe<Scalars['String']>,
};

export type UpdateExpertContactDetailsPayload = {
   __typename?: 'UpdateExpertContactDetailsPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertInput = {
  clientMutationId: Scalars['String'],
  dailyRate?: Maybe<Scalars['Float']>,
  firstname?: Maybe<Scalars['String']>,
  hourlyRate?: Maybe<Scalars['Float']>,
  lastname?: Maybe<Scalars['String']>,
  locationId?: Maybe<Scalars['ID']>,
  phoneMobile?: Maybe<Scalars['String']>,
};

export type UpdateExpertInsuranceDeclarationInput = {
  clientMutationId: Scalars['String'],
  hasInsurance: Scalars['Boolean'],
  professionalIndemnityLimitInMillion?: Maybe<Scalars['Int']>,
  publicLiabilityLimitInMillion?: Maybe<Scalars['Int']>,
  workersCompensationCover?: Maybe<Scalars['Boolean']>,
};

export type UpdateExpertInsuranceDeclarationPayload = {
   __typename?: 'UpdateExpertInsuranceDeclarationPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertPayload = {
   __typename?: 'UpdateExpertPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertPaymentInformationInput = {
  abn?: Maybe<Scalars['String']>,
  acn?: Maybe<Scalars['String']>,
  ausResident?: Maybe<Scalars['Boolean']>,
  bankAccountType?: Maybe<BankAccountType>,
  clientMutationId: Scalars['String'],
  gstRegistered?: Maybe<Scalars['Boolean']>,
  hasInsurance?: Maybe<Scalars['Boolean']>,
  isLegallyAuthorised?: Maybe<Scalars['Boolean']>,
  operatingType?: Maybe<ConsultantBusinessType>,
  paypalEmail?: Maybe<Scalars['String']>,
  professionalIndemnityLimitInMillion?: Maybe<Scalars['Int']>,
  publicLiabilityLimitInMillion?: Maybe<Scalars['Int']>,
  registeredBusinessName?: Maybe<Scalars['String']>,
  residencyStatus?: Maybe<ResidencyStatusType>,
  residencyStatusOther?: Maybe<Scalars['String']>,
  workersCompensationCover?: Maybe<Scalars['Boolean']>,
};

export type UpdateExpertPaymentInformationPayload = {
   __typename?: 'UpdateExpertPaymentInformationPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertProfilePrivacyInput = {
  clientMutationId: Scalars['String'],
  privacy: ExpertProfilePrivacy,
};

export type UpdateExpertProfilePrivacyPayload = {
   __typename?: 'UpdateExpertProfilePrivacyPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertRatesInput = {
  clientMutationId: Scalars['String'],
  currency?: Maybe<Scalars['String']>,
  maxDailyRate?: Maybe<Scalars['Decimal']>,
  maxHourlyRate?: Maybe<Scalars['Decimal']>,
  minDailyRate?: Maybe<Scalars['Decimal']>,
  minHourlyRate?: Maybe<Scalars['Decimal']>,
};

export type UpdateExpertRatesPayload = {
   __typename?: 'UpdateExpertRatesPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateExpertTaxSettingsInput = {
  ausResident?: Maybe<Scalars['Boolean']>,
  clientMutationId: Scalars['String'],
  gstRegistered?: Maybe<Scalars['Boolean']>,
};

export type UpdateExpertTaxSettingsPayload = {
   __typename?: 'UpdateExpertTaxSettingsPayload',
  clientMutationId: Scalars['String'],
  user?: Maybe<UserV2>,
};

export type UpdateOrganisationDetailsInput = {
  clientMutationId: Scalars['String'],
  crn: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type UpdateOrganisationDetailsPayload = {
   __typename?: 'UpdateOrganisationDetailsPayload',
  clientMutationId: Scalars['String'],
  organisation?: Maybe<Organisation>,
};

export type UpdatePasswordInput = {
  clientMutationId: Scalars['String'],
  currentPassword: Scalars['String'],
  newPassword: Scalars['String'],
};

export type UpdatePasswordPayload = {
   __typename?: 'UpdatePasswordPayload',
  clientMutationId: Scalars['String'],
  confirmation?: Maybe<Scalars['Boolean']>,
};

export type UpdateProfileInput = {
  clientMutationId: Scalars['String'],
  code: Scalars['String'],
  headline?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
};

export type UpdateProfilePayload = {
   __typename?: 'UpdateProfilePayload',
  clientMutationId: Scalars['String'],
  lifecycle?: Maybe<Lifecycle>,
  profile?: Maybe<ProfileV2>,
};

export type UpdateProjectInput = {
  clientMutationId: Scalars['String'],
  projectBrief?: Maybe<ProjectBriefInput>,
  projectId: Scalars['ID'],
};

export type UpdateProjectPayload = {
   __typename?: 'UpdateProjectPayload',
  clientMutationId: Scalars['String'],
  project?: Maybe<ProjectV2>,
};

export type UpdateSkillsInput = {
  clientMutationId: Scalars['String'],
  skills: Array<SkillInput>,
};

export type UpdateSkillsPayload = {
   __typename?: 'UpdateSkillsPayload',
  clientMutationId: Scalars['String'],
  skills?: Maybe<Array<Maybe<Skill>>>,
};

export type UpdateWorkItemInput = {
  clientMutationId: Scalars['String'],
  workItem?: Maybe<WorkItemInput>,
  workItemId: Scalars['ID'],
};

export type UpdateWorkItemPayload = {
   __typename?: 'UpdateWorkItemPayload',
  clientMutationId: Scalars['String'],
  workItem?: Maybe<WorkHistoryV2>,
};

export type User = Node & {
   __typename?: 'User',
  abn?: Maybe<Scalars['String']>,
  accountUrl?: Maybe<Scalars['String']>,
  activePostedProjects?: Maybe<Array<Project>>,
  availability?: Maybe<AvailabilityV3>,
  averageProjectRating?: Maybe<Scalars['Float']>,
  currency?: Maybe<Scalars['String']>,
  dailyRate?: Maybe<Scalars['Float']>,
  dateCreated?: Maybe<Scalars['NaiveDateTime']>,
  dateUpdated?: Maybe<Scalars['NaiveDateTime']>,
  email?: Maybe<Scalars['String']>,
  firstname?: Maybe<Scalars['String']>,
  gstRegistered?: Maybe<Scalars['Boolean']>,
  hourlyRate?: Maybe<Scalars['Float']>,
  /** The ID of an object */
  id: Scalars['ID'],
  /** Whether or not the user is an admin of any organisation. */
  isOrgAdmin?: Maybe<Scalars['Boolean']>,
  lastname?: Maybe<Scalars['String']>,
  location?: Maybe<LegacyLocation>,
  locked?: Maybe<Scalars['Boolean']>,
  organisation?: Maybe<Organisation>,
  organisationRole?: Maybe<OrganisationRole>,
  phoneMobile?: Maybe<Scalars['String']>,
  private?: Maybe<Scalars['Boolean']>,
  profilePicture?: Maybe<ProfilePicture>,
  profileUrl?: Maybe<Scalars['String']>,
  publicCode?: Maybe<Scalars['String']>,
  reviews: Array<RatingAndReview>,
  role?: Maybe<Scalars['String']>,
  status: StatusOptions,
  timezone?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  verificationLevel?: Maybe<VerificationLevel>,
  viewerHasFavourited: Scalars['Boolean'],
};


export type UserProfilePictureArgs = {
  size: ProfilePictureSize
};

export enum UserRoleV2 {
  Admin = 'ADMIN',
  Consultant = 'CONSULTANT',
  Superadmin = 'SUPERADMIN',
  Client = 'CLIENT'
}

export type UserV2 = Node & {
   __typename?: 'UserV2',
  applicationNotes?: Maybe<Scalars['String']>,
  claimed?: Maybe<Scalars['Boolean']>,
  /** 
 * Details specific to a client.
   * 
   * `clientV2` when the user's role is `user`, and `null` when the user has any other role.
 */
  client?: Maybe<ClientV2>,
  /** 
 * Details specific to a consultant.
   * 
   * `ConsultantV2` when the user's role is `CONSULTANT`, and `null` when the user has any other role.
 */
  consultant?: Maybe<ConsultantV2>,
  currency?: Maybe<Scalars['String']>,
  dailyRate?: Maybe<Scalars['Float']>,
  dateCreated?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  firstname?: Maybe<Scalars['String']>,
  hourlyRate?: Maybe<Scalars['Float']>,
  /** The ID of an object */
  id: Scalars['ID'],
  isImpersonating?: Maybe<Scalars['Boolean']>,
  lastname?: Maybe<Scalars['String']>,
  location?: Maybe<LegacyLocation>,
  locationId?: Maybe<Scalars['ID']>,
  locked?: Maybe<Scalars['Boolean']>,
  operatingType?: Maybe<OperatingType>,
  organisationRole?: Maybe<OrganisationRole>,
  phoneMobile?: Maybe<Scalars['String']>,
  platformWhitelabelling?: Maybe<Scalars['String']>,
  profilePicture?: Maybe<ProfilePicture>,
  profilePictureDomain?: Maybe<Scalars['String']>,
  publicCode?: Maybe<Scalars['String']>,
  registeredBusinessName?: Maybe<Scalars['String']>,
  role?: Maybe<UserRoleV2>,
  source?: Maybe<Scalars['String']>,
  timezone?: Maybe<Scalars['String']>,
  uploadedCv?: Maybe<Scalars['String']>,
  verificationLevel?: Maybe<VerificationLevel>,
  workingSituation?: Maybe<WorkingSituation>,
};


export type UserV2ProfilePictureArgs = {
  size: ProfilePictureSize
};

export type UserV2Connection = {
   __typename?: 'UserV2Connection',
  edges?: Maybe<Array<Maybe<UserV2Edge>>>,
  pageInfo: PageInfo,
};

export type UserV2Edge = {
   __typename?: 'UserV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<UserV2>,
};

export type V2 = {
   __typename?: 'V2',
  /** Business Services */
  businessServices?: Maybe<BusinessServiceConnection>,
  countries?: Maybe<Array<Maybe<Country>>>,
  /** Industry Autocomplete */
  industryAutocomplete?: Maybe<IndustryConnection>,
  /** A single invoice */
  invoice?: Maybe<PaymentInvoice>,
  /** Submitted invoices */
  invoices?: Maybe<PaymentInvoiceConnection>,
  isAccountClaimed?: Maybe<Scalars['Boolean']>,
  isEmailAvailableForSignup?: Maybe<Scalars['Boolean']>,
  /** Legacy Locations */
  legacyLocations?: Maybe<LegacyLocationConnection>,
  /** Legacy Organisations */
  legacyOrganisations?: Maybe<LegacyOrganisationConnection>,
  /** Organisation details */
  organisation?: Maybe<Organisation>,
  /** Single invitation */
  organisationInvitation?: Maybe<OrganisationInvitation>,
  /** Multiple invitations */
  organisationInvitations?: Maybe<OrganisationInvitationConnection>,
  /** Organisation members */
  organisationMembers?: Maybe<UserV2Connection>,
  /** Organisations */
  organisations?: Maybe<OrganisationConnection>,
  /** A single project */
  project?: Maybe<ProjectV2>,
  /** Role Titles */
  roleTitles?: Maybe<RoleTitleConnection>,
  /** 
 * Details for the currently logged in user (the user viewing the page).
   * 
   * This contains session information as well as the user entity associated with the session.
   * 
   * `ViewerV2` if the user has authenticated. `null` when the user is logged out.
 */
  viewer?: Maybe<ViewerV2>,
};


export type V2BusinessServicesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>
};


export type V2CountriesArgs = {
  alpha2?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>
};


export type V2IndustryAutocompleteArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name: Scalars['String']
};


export type V2InvoiceArgs = {
  code?: Maybe<Scalars['String']>
};


export type V2InvoicesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  startDate?: Maybe<Scalars['String']>
};


export type V2IsAccountClaimedArgs = {
  email?: Maybe<Scalars['String']>
};


export type V2IsEmailAvailableForSignupArgs = {
  email?: Maybe<Scalars['String']>
};


export type V2LegacyLocationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>
};


export type V2LegacyOrganisationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name: Scalars['String']
};


export type V2OrganisationArgs = {
  email?: Maybe<Scalars['String']>
};


export type V2OrganisationInvitationArgs = {
  code?: Maybe<Scalars['String']>
};


export type V2OrganisationInvitationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type V2OrganisationMembersArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type V2OrganisationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>
};


export type V2ProjectArgs = {
  code?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>
};


export type V2RoleTitlesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>
};

export enum VerificationLevel {
  Unvetted = 'UNVETTED',
  Vetted = 'VETTED',
  Futured = 'FUTURED'
}

export type Viewer = Node & {
   __typename?: 'Viewer',
  /** The ID of an object */
  id: Scalars['ID'],
  isImpersonating?: Maybe<Scalars['Boolean']>,
  role?: Maybe<Role>,
  user?: Maybe<User>,
};

export type ViewerInvitation = {
   __typename?: 'ViewerInvitation',
  date?: Maybe<Scalars['Timestamp']>,
  declinedInvitation?: Maybe<DeclinedInvitation>,
};

export type ViewerV2 = {
   __typename?: 'ViewerV2',
  /** 
 * Whether or not the viewer has unread messages.
   * 
   * This field always returns `false` for logged out users.
 */
  hasMessages?: Maybe<Scalars['Boolean']>,
  /** 
 * The user entity for viewer. This contains detiails for the currently logged in user.
   * 
   * If impersonating, this will be the impersonated user.
 */
  user?: Maybe<UserV2>,
};

export type WorkHistoryV2 = Node & {
   __typename?: 'WorkHistoryV2',
  businessServices?: Maybe<Array<BusinessService>>,
  /** 
 * The end month of the work history item. Values will be an integer from `0`-`12` or `null`.
   * 
   * `1` through `12` represent January through December, sequentially.
   * 
   * `0` and `null` represent empty values.
   * 
   * This field has no meaning if `isCurrent` is `true`.
 */
  endMonth?: Maybe<Scalars['Int']>,
  /** 
 * The end year of the work history item. Values will be an integer from `1901`-`2155`, `0`, or `null`.
   * 
   * `0` and `null` represent empty values.
   * 
   * This field has no meaning if `isCurrent` is `true`.
 */
  endYear?: Maybe<Scalars['Int']>,
  expertOrganisations?: Maybe<Array<LegacyOrganisation>>,
  /** The ID of an object */
  id: Scalars['ID'],
  industries?: Maybe<Array<Maybe<Industry>>>,
  /** 
 * A flag designating whether or not the work history item is currently in progress. For historical reasons,
   * `endMonth` and `endYear` have no meaning if this field is `true`.
 */
  isCurrent?: Maybe<Scalars['Boolean']>,
  /** The organisation that the work was performed for. */
  organisation?: Maybe<LegacyOrganisation>,
  /** 
 * The start month of the work history item. Values will be an integer from `0`-`12` or `null`.
   * 
   * `1` through `12` represent January through December, sequentially.
   * 
   * `0` and `null` represent empty values.
 */
  startMonth?: Maybe<Scalars['Int']>,
  /** 
 * The start year of the work history item. Values will be an integer from `1901`-`2155`, `0`, or `null`.
   * 
   * `0` and `null` represent empty values.
 */
  startYear?: Maybe<Scalars['Int']>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
  urlDescription?: Maybe<Scalars['String']>,
};

export type WorkHistoryV2Connection = {
   __typename?: 'WorkHistoryV2Connection',
  edges?: Maybe<Array<Maybe<WorkHistoryV2Edge>>>,
  pageInfo: PageInfo,
};

export type WorkHistoryV2Edge = {
   __typename?: 'WorkHistoryV2Edge',
  cursor?: Maybe<Scalars['String']>,
  node?: Maybe<WorkHistoryV2>,
};

export enum WorkingSituation {
  Available = 'AVAILABLE',
  Considering = 'CONSIDERING'
}

export type WorkItem = Node & {
   __typename?: 'WorkItem',
  businessServices?: Maybe<Array<BusinessService>>,
  endMonth?: Maybe<Scalars['Int']>,
  endYear?: Maybe<Scalars['Int']>,
  expertOrganisations?: Maybe<Array<LegacyOrganisation>>,
  /** The ID of an object */
  id: Scalars['ID'],
  isCurrent?: Maybe<Scalars['Boolean']>,
  organisation?: Maybe<LegacyOrganisation>,
  selfEmployed?: Maybe<Scalars['Boolean']>,
  startMonth: Scalars['Int'],
  startYear?: Maybe<Scalars['Int']>,
  summary?: Maybe<Scalars['HtmlRichText']>,
  title?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
  urlDescription?: Maybe<Scalars['String']>,
};

export type WorkItemInput = {
  businessServices: Array<ServiceInput>,
  company?: Maybe<Scalars['String']>,
  customBusinessServices?: Maybe<Array<Scalars['String']>>,
  endMonth?: Maybe<Scalars['Int']>,
  endYear?: Maybe<Scalars['Int']>,
  expertOrganisations: Array<ExpertOrganisationInput>,
  industries: Array<IndustryInput>,
  isCurrent?: Maybe<Scalars['Boolean']>,
  organisationId?: Maybe<Scalars['ID']>,
  roleTitleId?: Maybe<Scalars['ID']>,
  startMonth?: Maybe<Scalars['Int']>,
  startYear?: Maybe<Scalars['Int']>,
  summary?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
  urlDescription?: Maybe<Scalars['String']>,
};

export type ClientProjectSummary_GraphFragment = (
  { __typename?: 'V2' }
  & { viewer: Maybe<(
    { __typename?: 'ViewerV2' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { client: Maybe<(
        { __typename?: 'ClientV2' }
        & { memberOf: Array<(
          { __typename?: 'Organisation' }
          & Pick<Organisation, 'name' | 'id'>
        )>, project: Maybe<(
          { __typename?: 'ProjectV2' }
          & Pick<ProjectV2, 'title' | 'code' | 'hash' | 'unlisted' | 'summary' | 'companyType' | 'industry' | 'duration' | 'dateStart' | 'startAsap' | 'earn' | 'budgetCurrency' | 'locationType' | 'intensity' | 'postedDateUtc' | 'applicantCount' | 'state' | 'companyName' | 'isInsured' | 'idealExpertSummary' | 'idealExpertTitle'>
          & { servicesRequired: Array<(
            { __typename?: 'BusinessService' }
            & Pick<BusinessService, 'name'>
          )>, unapprovedServicesRequired: Array<(
            { __typename?: 'BusinessService' }
            & Pick<BusinessService, 'name'>
          )>, industries: Array<(
            { __typename?: 'Industry' }
            & Pick<Industry, 'name'>
          )>, locationDetails: Maybe<(
            { __typename?: 'LegacyLocation' }
            & Pick<LegacyLocation, 'city' | 'country'>
          )>, organisations: Maybe<Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'id' | 'name'>
          )>>, status: Maybe<(
            { __typename?: 'ProjectStatus' }
            & Pick<ProjectStatus, 'applicationCount' | 'interviewCount' | 'offerCount' | 'expertStatus' | 'expertStatusDate'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type AddApplicationViewedInteractionMutationVariables = {
  input: AddApplicationViewedInteractionInput
};


export type AddApplicationViewedInteractionMutation = (
  { __typename?: 'Mutation' }
  & { addApplicationViewedInteraction: Maybe<(
    { __typename?: 'AddApplicationViewedInteractionPayload' }
    & { application: Maybe<(
      { __typename?: 'ApplicationV2' }
      & { applicantStatus: Maybe<(
        { __typename?: 'ApplicantStatus' }
        & Pick<ApplicantStatus, 'viewed'>
      )> }
    )> }
  )> }
);

export type CancelProjectMutationVariables = {
  input: CancelProjectInput
};


export type CancelProjectMutation = (
  { __typename?: 'Mutation' }
  & { cancelProject: Maybe<(
    { __typename?: 'CancelProjectPayload' }
    & { project: Maybe<(
      { __typename?: 'ProjectV2' }
      & Pick<ProjectV2, 'id' | 'state'>
    )> }
  )> }
);

export type DeclineExpertApplicationMutationVariables = {
  input: DeclineExpertApplicationInput
};


export type DeclineExpertApplicationMutation = (
  { __typename?: 'Mutation' }
  & { declineExpertApplication: Maybe<(
    { __typename?: 'DeclineExpertApplicationPayload' }
    & { application: Maybe<(
      { __typename?: 'ApplicationV2' }
      & { applicantStatus: Maybe<(
        { __typename?: 'ApplicantStatus' }
        & Pick<ApplicantStatus, 'expertStatus' | 'expertDeclinedReason'>
      )> }
    )> }
  )> }
);

export type InviteExpertToInterviewMutationVariables = {
  input: InviteExpertToInterviewInput
};


export type InviteExpertToInterviewMutation = (
  { __typename?: 'Mutation' }
  & { inviteExpertToInterview: Maybe<(
    { __typename?: 'InviteExpertToInterviewPayload' }
    & { application: Maybe<(
      { __typename?: 'ApplicationV2' }
      & { applicantStatus: Maybe<(
        { __typename?: 'ApplicantStatus' }
        & Pick<ApplicantStatus, 'expertStatus'>
      )> }
    )> }
  )> }
);

export type OnholdProjectMutationVariables = {
  input: OnholdProjectInput
};


export type OnholdProjectMutation = (
  { __typename?: 'Mutation' }
  & { onholdProject: Maybe<(
    { __typename?: 'OnholdProjectPayload' }
    & { project: Maybe<(
      { __typename?: 'ProjectV2' }
      & Pick<ProjectV2, 'id' | 'state'>
    )> }
  )> }
);

export type PauseProjectMutationVariables = {
  input: PauseProjectInput
};


export type PauseProjectMutation = (
  { __typename?: 'Mutation' }
  & { pauseProject: Maybe<(
    { __typename?: 'PauseProjectPayload' }
    & { project: Maybe<(
      { __typename?: 'ProjectV2' }
      & Pick<ProjectV2, 'id' | 'state'>
    )> }
  )> }
);

export type UnpauseProjectMutationVariables = {
  input: UnpauseProjectInput
};


export type UnpauseProjectMutation = (
  { __typename?: 'Mutation' }
  & { unpauseProject: Maybe<(
    { __typename?: 'UnpauseProjectPayload' }
    & { project: Maybe<(
      { __typename?: 'ProjectV2' }
      & Pick<ProjectV2, 'id' | 'state'>
    )> }
  )> }
);

export type ContractListQueryVariables = {
  code?: Maybe<Scalars['String']>
};


export type ContractListQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { project: Maybe<(
            { __typename?: 'ProjectV2' }
            & Pick<ProjectV2, 'id' | 'title' | 'code' | 'state' | 'unlisted' | 'usesOneRatePricingModel'>
            & { offers: Maybe<(
              { __typename?: 'ContractConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ContractEdge' }
                & { node: Maybe<(
                  { __typename?: 'Contract' }
                  & Pick<Contract, 'code'>
                )> }
              )>>> }
            )>, agreedContracts: Maybe<(
              { __typename?: 'ContractConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ContractEdge' }
                & { node: Maybe<(
                  { __typename?: 'Contract' }
                  & Pick<Contract, 'code' | 'currency' | 'amount' | 'budgetUnit' | 'startDate' | 'agreedDate' | 'createdDate' | 'status'>
                  & { expert: Maybe<(
                    { __typename?: 'User' }
                    & Pick<User, 'firstname' | 'lastname' | 'profileUrl'>
                    & { profilePicture: Maybe<(
                      { __typename?: 'ProfilePicture' }
                      & Pick<ProfilePicture, 'source'>
                    )> }
                  )>, review: Maybe<(
                    { __typename?: 'RatingAndReview' }
                    & Pick<RatingAndReview, 'hash'>
                    & { feedbackUserPublic: Maybe<(
                      { __typename?: 'FeedbackUserPublic' }
                      & Pick<FeedbackUserPublic, 'rating' | 'review'>
                    )> }
                  )> }
                )> }
              )>>> }
            )> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ExpertsToReviewQueryVariables = {
  code?: Maybe<Scalars['String']>
};


export type ExpertsToReviewQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { project: Maybe<(
            { __typename?: 'ProjectV2' }
            & Pick<ProjectV2, 'id' | 'title' | 'code' | 'unlisted' | 'state' | 'dateStart' | 'duration' | 'budgetCurrency' | 'budgetMin' | 'summary' | 'rateUnit' | 'contractTerms' | 'usesOneRatePricingModel'>
            & { createdBy: Maybe<(
              { __typename?: 'User' }
              & Pick<User, 'publicCode'>
              & { organisation: Maybe<(
                { __typename?: 'Organisation' }
                & Pick<Organisation, 'name' | 'commission' | 'hasMarketplace'>
              )> }
            )>, offers: Maybe<(
              { __typename?: 'ContractConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ContractEdge' }
                & { node: Maybe<(
                  { __typename?: 'Contract' }
                  & Pick<Contract, 'code' | 'status' | 'amount' | 'budgetUnit' | 'currency' | 'startDate' | 'createdDate'>
                  & { expert: Maybe<(
                    { __typename?: 'User' }
                    & Pick<User, 'firstname' | 'lastname' | 'profileUrl' | 'publicCode'>
                    & { profilePicture: Maybe<(
                      { __typename?: 'ProfilePicture' }
                      & Pick<ProfilePicture, 'source'>
                    )> }
                  )> }
                )> }
              )>>> }
            )>, agreedContracts: Maybe<(
              { __typename?: 'ContractConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ContractEdge' }
                & { node: Maybe<(
                  { __typename?: 'Contract' }
                  & Pick<Contract, 'code'>
                  & { expert: Maybe<(
                    { __typename?: 'User' }
                    & Pick<User, 'profileUrl' | 'publicCode'>
                  )> }
                )> }
              )>>> }
            )>, applications: Maybe<(
              { __typename?: 'ApplicationV2Connection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ApplicationV2Edge' }
                & { node: Maybe<(
                  { __typename?: 'ApplicationV2' }
                  & Pick<ApplicationV2, 'id' | 'dateSubmitted' | 'budget' | 'dateStart' | 'statement' | 'proposedRate' | 'proposedRateUnit'>
                  & { applicant: Maybe<(
                    { __typename?: 'UserV2' }
                    & Pick<UserV2, 'id' | 'firstname' | 'lastname' | 'phoneMobile' | 'email' | 'publicCode'>
                    & { consultant: Maybe<(
                      { __typename?: 'ConsultantV2' }
                      & Pick<ConsultantV2, 'averageProjectRating' | 'projectCount'>
                      & { profile: Maybe<(
                        { __typename?: 'ProfileV2' }
                        & Pick<ProfileV2, 'code' | 'headline'>
                      )>, paymentInformation: Maybe<(
                        { __typename?: 'PaymentInformationV2' }
                        & Pick<PaymentInformationV2, 'gstRegistered'>
                      )> }
                    )>, profilePicture: Maybe<(
                      { __typename?: 'ProfilePicture' }
                      & Pick<ProfilePicture, 'source'>
                    )> }
                  )>, applicantStatus: Maybe<(
                    { __typename?: 'ApplicantStatus' }
                    & Pick<ApplicantStatus, 'recommended' | 'viewed' | 'invited' | 'expertStatus' | 'expertDeclinedReason'>
                  )>, selectedExperiences: Maybe<(
                    { __typename?: 'ApplicationExperienceV2Connection' }
                    & { edges: Maybe<Array<Maybe<(
                      { __typename?: 'ApplicationExperienceV2Edge' }
                      & { node: Maybe<(
                        { __typename?: 'ApplicationExperienceV2' }
                        & Pick<ApplicationExperienceV2, 'id' | 'description'>
                        & { item: Maybe<(
                          { __typename: 'ProjectV2' }
                          & Pick<ProjectV2, 'id' | 'title' | 'dateStart' | 'dateCompleted'>
                        ) | (
                          { __typename: 'WorkHistoryV2' }
                          & Pick<WorkHistoryV2, 'id' | 'title' | 'startMonth' | 'startYear' | 'endMonth' | 'endYear' | 'isCurrent'>
                          & { organisation: Maybe<(
                            { __typename?: 'LegacyOrganisation' }
                            & Pick<LegacyOrganisation, 'name'>
                          )> }
                        )> }
                      )> }
                    )>>> }
                  )> }
                )> }
              )>>> }
            )> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type PageClientProjectDetailsQueryVariables = {
  code?: Maybe<Scalars['String']>
};


export type PageClientProjectDetailsQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { memberOf: Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'isTimesheetRequired'>
          )>, project: Maybe<(
            { __typename?: 'ProjectV2' }
            & Pick<ProjectV2, 'id' | 'title' | 'code' | 'hash' | 'unlisted' | 'state' | 'dateCreated' | 'isCreator'>
            & { offers: Maybe<(
              { __typename?: 'ContractConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'ContractEdge' }
                & { node: Maybe<(
                  { __typename?: 'Contract' }
                  & Pick<Contract, 'code'>
                )> }
              )>>> }
            )>, invoices: Maybe<(
              { __typename?: 'PaymentInvoiceConnection' }
              & { edges: Maybe<Array<Maybe<(
                { __typename?: 'PaymentInvoiceEdge' }
                & { node: Maybe<(
                  { __typename?: 'PaymentInvoice' }
                  & Pick<PaymentInvoice, 'id' | 'code' | 'status' | 'dateCreated' | 'expertName' | 'clientName' | 'dateStart' | 'dateEnd' | 'dateStatusUpdated'>
                )> }
              )>>> }
            )> }
          )> }
        )> }
      )> }
    )> }
    & ClientProjectSummary_GraphFragment
  )> }
);

export type ClientProjectArchivedCard_ProjectFragment = (
  { __typename?: 'ProjectV2' }
  & Pick<ProjectV2, 'id' | 'code' | 'dateCreated' | 'title' | 'state' | 'privacy' | 'unlisted' | 'isCreator'>
  & { createdBy: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstname' | 'lastname'>
  )>, status: Maybe<(
    { __typename?: 'ProjectStatus' }
    & Pick<ProjectStatus, 'applicationCount' | 'interviewCount' | 'offerCount'>
  )>, agreedContracts: Maybe<(
    { __typename?: 'ContractConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'ContractEdge' }
      & { node: Maybe<(
        { __typename?: 'Contract' }
        & Pick<Contract, 'code'>
        & { expert: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'firstname'>
          & { profilePicture: Maybe<(
            { __typename?: 'ProfilePicture' }
            & Pick<ProfilePicture, 'source'>
          )> }
        )>, review: Maybe<(
          { __typename?: 'RatingAndReview' }
          & Pick<RatingAndReview, 'hash'>
          & { feedbackUserPublic: Maybe<(
            { __typename?: 'FeedbackUserPublic' }
            & Pick<FeedbackUserPublic, 'rating' | 'review'>
          )> }
        )> }
      )> }
    )>>> }
  )> }
);

export type ClientProjectArchivedList_GraphFragment = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { projects: Maybe<(
            { __typename?: 'ProjectV2Connection' }
            & { edges: Maybe<Array<Maybe<(
              { __typename?: 'ProjectV2Edge' }
              & { node: Maybe<(
                { __typename?: 'ProjectV2' }
                & Pick<ProjectV2, 'id'>
                & ClientProjectArchivedCard_ProjectFragment
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ClientProjectArchivedTabQueryVariables = {
  filter?: Maybe<ClientProjectFilter>,
  count: Scalars['Int']
};


export type ClientProjectArchivedTabQuery = (
  { __typename?: 'Query' }
  & ClientProjectArchivedList_GraphFragment
);

export type ClientProjectFilledCard_ProjectFragment = (
  { __typename?: 'ProjectV2' }
  & Pick<ProjectV2, 'id' | 'code' | 'dateCreated' | 'title' | 'unlisted' | 'isCreator'>
  & { createdBy: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstname' | 'lastname'>
  )>, agreedContracts: Maybe<(
    { __typename?: 'ContractConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'ContractEdge' }
      & { node: Maybe<(
        { __typename?: 'Contract' }
        & Pick<Contract, 'code' | 'startDate' | 'endDate'>
        & { expert: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'firstname'>
          & { profilePicture: Maybe<(
            { __typename?: 'ProfilePicture' }
            & Pick<ProfilePicture, 'source'>
          )> }
        )> }
      )> }
    )>>> }
  )> }
);

export type ClientProjectFilledList_GraphFragment = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { projects: Maybe<(
            { __typename?: 'ProjectV2Connection' }
            & { edges: Maybe<Array<Maybe<(
              { __typename?: 'ProjectV2Edge' }
              & { node: Maybe<(
                { __typename?: 'ProjectV2' }
                & Pick<ProjectV2, 'id'>
                & ClientProjectFilledCard_ProjectFragment
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ClientProjectFilledTabQueryVariables = {
  filter?: Maybe<ClientProjectFilter>,
  count: Scalars['Int']
};


export type ClientProjectFilledTabQuery = (
  { __typename?: 'Query' }
  & ClientProjectFilledList_GraphFragment
);

export type ClientProjectSourcingCard_ProjectFragment = (
  { __typename?: 'ProjectV2' }
  & Pick<ProjectV2, 'id' | 'code' | 'dateCreated' | 'title' | 'state' | 'privacy' | 'unlisted' | 'isSharedWithPrivateCloud' | 'isCreator'>
  & { createdBy: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstname' | 'lastname'>
  )>, status: Maybe<(
    { __typename?: 'ProjectStatus' }
    & Pick<ProjectStatus, 'applicationCount' | 'interviewCount' | 'offerCount'>
  )>, offers: Maybe<(
    { __typename?: 'ContractConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'ContractEdge' }
      & { node: Maybe<(
        { __typename?: 'Contract' }
        & Pick<Contract, 'code' | 'status'>
      )> }
    )>>> }
  )> }
);

export type ClientProjectSourcingList_GraphFragment = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'organisationRole'>
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { projects: Maybe<(
            { __typename?: 'ProjectV2Connection' }
            & { edges: Maybe<Array<Maybe<(
              { __typename?: 'ProjectV2Edge' }
              & { node: Maybe<(
                { __typename?: 'ProjectV2' }
                & Pick<ProjectV2, 'id'>
                & ClientProjectSourcingCard_ProjectFragment
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ClientProjectSourcingTabQueryVariables = {
  filter?: Maybe<ClientProjectFilter>,
  count: Scalars['Int']
};


export type ClientProjectSourcingTabQuery = (
  { __typename?: 'Query' }
  & ClientProjectSourcingList_GraphFragment
);

export type ActivateProjectMutationVariables = {
  input: ActivateProjectInput
};


export type ActivateProjectMutation = (
  { __typename?: 'Mutation' }
  & { activateProject: Maybe<(
    { __typename?: 'ActivateProjectPayload' }
    & { project: Maybe<(
      { __typename?: 'ProjectV2' }
      & Pick<ProjectV2, 'code' | 'state'>
    )> }
  )> }
);

export type ClientAcceptOfferMutationVariables = {
  input: AcceptOfferInput
};


export type ClientAcceptOfferMutation = (
  { __typename?: 'Mutation' }
  & { acceptOffer: Maybe<(
    { __typename?: 'AcceptOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code' | 'title' | 'amount' | 'currency' | 'budgetType' | 'budgetUnit' | 'status' | 'createdDate' | 'startDate' | 'endDate' | 'agreedDate' | 'duration' | 'durationUnit' | 'allowReimbursements' | 'expensesCovered' | 'requiredReceipts' | 'milestones' | 'detail'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstname' | 'lastname' | 'abn'>
        & { profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )> }
      )> }
    )> }
  )> }
);

export type ClientCreateOfferMutationVariables = {
  input: CreateOfferInput
};


export type ClientCreateOfferMutation = (
  { __typename?: 'Mutation' }
  & { createOffer: Maybe<(
    { __typename?: 'CreateOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'publicCode'>
      )> }
    )> }
  )> }
);

export type ClientModifyOfferMutationVariables = {
  input: ModifyOfferInput
};


export type ClientModifyOfferMutation = (
  { __typename?: 'Mutation' }
  & { modifyOffer: Maybe<(
    { __typename?: 'ModifyOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'publicCode'>
      )> }
    )> }
  )> }
);

export type ExpertAcceptOfferMutationVariables = {
  input: AcceptOfferInput
};


export type ExpertAcceptOfferMutation = (
  { __typename?: 'Mutation' }
  & { acceptOffer: Maybe<(
    { __typename?: 'AcceptOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code' | 'title' | 'amount' | 'currency' | 'budgetType' | 'budgetUnit' | 'status' | 'createdDate' | 'startDate' | 'endDate' | 'agreedDate' | 'duration' | 'durationUnit' | 'allowReimbursements' | 'expensesCovered' | 'requiredReceipts' | 'milestones' | 'detail'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstname' | 'lastname' | 'abn'>
        & { profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )> }
      )> }
    )> }
  )> }
);

export type ExpertCounterOfferMutationVariables = {
  input: ModifyOfferInput
};


export type ExpertCounterOfferMutation = (
  { __typename?: 'Mutation' }
  & { modifyOffer: Maybe<(
    { __typename?: 'ModifyOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code' | 'title' | 'createdDate' | 'agreedDate' | 'status' | 'detail' | 'milestones' | 'allowReimbursements' | 'requiredReceipts' | 'expensesCovered' | 'amount' | 'budgetUnit' | 'currency' | 'startDate' | 'duration' | 'durationUnit' | 'terms'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstname' | 'lastname' | 'abn' | 'gstRegistered' | 'publicCode'>
        & { profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )> }
      )> }
    )> }
  )> }
);

export type ExpertCreateOfferMutationVariables = {
  input: CreateOfferInput
};


export type ExpertCreateOfferMutation = (
  { __typename?: 'Mutation' }
  & { createOffer: Maybe<(
    { __typename?: 'CreateOfferPayload' }
    & { contract: Maybe<(
      { __typename?: 'Contract' }
      & Pick<Contract, 'id' | 'code' | 'title' | 'createdDate' | 'agreedDate' | 'status' | 'detail' | 'milestones' | 'allowReimbursements' | 'requiredReceipts' | 'expensesCovered' | 'amount' | 'budgetUnit' | 'currency' | 'startDate' | 'duration' | 'durationUnit' | 'terms'>
      & { expert: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstname' | 'lastname' | 'abn' | 'gstRegistered'>
        & { profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )> }
      )> }
    )> }
  )> }
);

export type ContractDetailsQueryVariables = {
  projectCode?: Maybe<Scalars['String']>,
  contractCode?: Maybe<Scalars['String']>
};


export type ContractDetailsQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'role'>
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { memberOf: Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'name' | 'paymentTermDays' | 'expertPaymentTermDays'>
          )>, project: Maybe<(
            { __typename?: 'ProjectV2' }
            & Pick<ProjectV2, 'id' | 'title' | 'code' | 'state' | 'unlisted' | 'usesOneRatePricingModel'>
            & { createdBy: Maybe<(
              { __typename?: 'User' }
              & Pick<User, 'firstname' | 'lastname' | 'role' | 'publicCode'>
              & { profilePicture: Maybe<(
                { __typename?: 'ProfilePicture' }
                & Pick<ProfilePicture, 'source'>
              )>, organisation: Maybe<(
                { __typename?: 'Organisation' }
                & Pick<Organisation, 'name' | 'paymentTermDays' | 'expertPaymentTermDays' | 'usesOneRatePricingModel'>
              )> }
            )> }
          )>, contract: Maybe<(
            { __typename?: 'Contract' }
            & Pick<Contract, 'id' | 'applicationId' | 'code' | 'title' | 'amount' | 'currency' | 'budgetType' | 'budgetUnit' | 'status' | 'createdDate' | 'startDate' | 'endDate' | 'agreedDate' | 'duration' | 'durationUnit' | 'allowReimbursements' | 'expensesCovered' | 'requiredReceipts' | 'milestones' | 'detail' | 'terms'>
            & { expert: Maybe<(
              { __typename?: 'User' }
              & Pick<User, 'firstname' | 'lastname' | 'abn' | 'gstRegistered' | 'profileUrl'>
              & { profilePicture: Maybe<(
                { __typename?: 'ProfilePicture' }
                & Pick<ProfilePicture, 'source'>
              )> }
            )>, relatedContracts: Maybe<Array<Maybe<(
              { __typename?: 'Contract' }
              & Pick<Contract, 'id' | 'code' | 'createdDate' | 'applicationId' | 'title' | 'amount' | 'currency' | 'budgetType' | 'budgetUnit' | 'status' | 'startDate' | 'endDate' | 'agreedDate' | 'duration' | 'durationUnit' | 'allowReimbursements' | 'expensesCovered' | 'requiredReceipts' | 'milestones' | 'detail' | 'terms'>
              & { expert: Maybe<(
                { __typename?: 'User' }
                & Pick<User, 'firstname' | 'lastname' | 'abn' | 'gstRegistered' | 'profileUrl'>
                & { profilePicture: Maybe<(
                  { __typename?: 'ProfilePicture' }
                  & Pick<ProfilePicture, 'source'>
                )> }
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ModifyOfferQueryVariables = {
  offerCode?: Maybe<Scalars['String']>
};


export type ModifyOfferQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'firstname' | 'lastname'>
        & { client: Maybe<(
          { __typename?: 'ClientV2' }
          & { memberOf: Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'name' | 'paymentTermDays' | 'expertPaymentTermDays'>
          )>, contract: Maybe<(
            { __typename?: 'Contract' }
            & Pick<Contract, 'id' | 'applicationId' | 'code' | 'title' | 'amount' | 'currency' | 'budgetType' | 'budgetUnit' | 'status' | 'createdDate' | 'startDate' | 'endDate' | 'agreedDate' | 'duration' | 'durationUnit' | 'allowReimbursements' | 'expensesCovered' | 'requiredReceipts' | 'milestones' | 'detail' | 'terms'>
            & { expert: Maybe<(
              { __typename?: 'User' }
              & Pick<User, 'firstname' | 'lastname' | 'abn'>
              & { profilePicture: Maybe<(
                { __typename?: 'ProfilePicture' }
                & Pick<ProfilePicture, 'source'>
              )> }
            )> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type UserContextHandlerQueryVariables = {};


export type UserContextHandlerQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'id' | 'role' | 'organisationRole' | 'verificationLevel' | 'email' | 'locked'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'accepted' | 'emailVerified' | 'basicProfileCompleted' | 'marketplaceMember' | 'privateCloudTalent'>
          )> }
        )>, client: Maybe<(
          { __typename?: 'ClientV2' }
          & { memberOf: Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'name' | 'hasExplore'>
            & { ssoConfig: Maybe<(
              { __typename?: 'SsoConfig' }
              & Pick<SsoConfig, 'requireSso'>
            )> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertRatesMutationVariables = {
  input: UpdateExpertRatesInput
};


export type UpdateExpertRatesMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertRates: Maybe<(
    { __typename?: 'UpdateExpertRatesPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & Pick<UserV2, 'currency'>
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { profile: Maybe<(
          { __typename?: 'ProfileV2' }
          & Pick<ProfileV2, 'minHourlyRate' | 'maxHourlyRate' | 'minDailyRate' | 'maxDailyRate'>
        )> }
      )> }
    )> }
  )> }
);

export type CreateEducationItemMutationVariables = {
  input: CreateEducationItemInput
};


export type CreateEducationItemMutation = (
  { __typename?: 'Mutation' }
  & { createEducationItem: Maybe<(
    { __typename?: 'CreateEducationItemPayload' }
    & { educationItem: Maybe<(
      { __typename?: 'EducationItem' }
      & Pick<EducationItem, 'id' | 'schoolName' | 'degree' | 'startYear' | 'endYear' | 'fieldOfStudy' | 'description'>
    )> }
  )> }
);

export type CreateWorkItemMutationVariables = {
  input: CreateWorkItemInput
};


export type CreateWorkItemMutation = (
  { __typename?: 'Mutation' }
  & { createWorkItem: Maybe<(
    { __typename?: 'CreateWorkItemPayload' }
    & { workItem: Maybe<(
      { __typename?: 'WorkHistoryV2' }
      & Pick<WorkHistoryV2, 'endMonth' | 'endYear' | 'isCurrent' | 'startMonth' | 'startYear' | 'summary' | 'title' | 'url' | 'urlDescription'>
      & { businessServices: Maybe<Array<(
        { __typename?: 'BusinessService' }
        & Pick<BusinessService, 'id' | 'isApproved' | 'name'>
      )>>, organisation: Maybe<(
        { __typename?: 'LegacyOrganisation' }
        & Pick<LegacyOrganisation, 'id' | 'name'>
      )>, expertOrganisations: Maybe<Array<(
        { __typename?: 'LegacyOrganisation' }
        & Pick<LegacyOrganisation, 'id' | 'name'>
      )>>, industries: Maybe<Array<Maybe<(
        { __typename?: 'Industry' }
        & Pick<Industry, 'id' | 'name'>
      )>>> }
    )>, lifecycle: Maybe<(
      { __typename?: 'Lifecycle' }
      & Pick<Lifecycle, 'id' | 'basicProfileCompleted'>
    )> }
  )> }
);

export type DeleteEducationItemMutationVariables = {
  input: DeleteEducationItemInput
};


export type DeleteEducationItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteEducationItem: Maybe<(
    { __typename?: 'DeleteEducationItemPayload' }
    & { educationItem: Maybe<(
      { __typename?: 'EducationItem' }
      & Pick<EducationItem, 'id'>
    )> }
  )> }
);

export type DeleteWorkItemMutationVariables = {
  input: DeleteWorkItemInput
};


export type DeleteWorkItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteWorkItem: Maybe<(
    { __typename?: 'DeleteWorkItemPayload' }
    & { workItem: Maybe<(
      { __typename?: 'WorkHistoryV2' }
      & Pick<WorkHistoryV2, 'id'>
    )> }
  )> }
);

export type UpdateEducationItemMutationVariables = {
  item: UpdateEducationItemInput
};


export type UpdateEducationItemMutation = (
  { __typename?: 'Mutation' }
  & { updateEducationItem: Maybe<(
    { __typename?: 'UpdateEducationItemPayload' }
    & { educationItem: Maybe<(
      { __typename?: 'EducationItem' }
      & Pick<EducationItem, 'id' | 'degree' | 'endYear' | 'fieldOfStudy' | 'schoolName' | 'startYear' | 'description'>
    )> }
  )> }
);

export type UpdateExpertAvailabilityMutationVariables = {
  input: UpdateExpertAvailabilityInput
};


export type UpdateExpertAvailabilityMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertAvailability: Maybe<(
    { __typename?: 'UpdateExpertAvailabilityPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { expertAvailability: Maybe<(
          { __typename?: 'AvailabilityV3' }
          & Pick<AvailabilityV3, 'currentAvailability' | 'unavailableUntilDate'>
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertMutationVariables = {
  input: UpdateExpertInput
};


export type UpdateExpertMutation = (
  { __typename?: 'Mutation' }
  & { updateExpert: Maybe<(
    { __typename?: 'UpdateExpertPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & Pick<UserV2, 'id' | 'firstname' | 'lastname' | 'hourlyRate' | 'dailyRate' | 'phoneMobile'>
      & { location: Maybe<(
        { __typename?: 'LegacyLocation' }
        & Pick<LegacyLocation, 'id' | 'city' | 'country'>
      )> }
    )> }
  )> }
);

export type UpdateProfileMutationVariables = {
  input: UpdateProfileInput
};


export type UpdateProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateProfile: Maybe<(
    { __typename?: 'UpdateProfilePayload' }
    & { profile: Maybe<(
      { __typename?: 'ProfileV2' }
      & Pick<ProfileV2, 'id' | 'summary' | 'headline'>
    )>, lifecycle: Maybe<(
      { __typename?: 'Lifecycle' }
      & Pick<Lifecycle, 'id' | 'basicProfileCompleted'>
    )> }
  )> }
);

export type UpdateSkillsMutationVariables = {
  input: UpdateSkillsInput
};


export type UpdateSkillsMutation = (
  { __typename?: 'Mutation' }
  & { updateSkills: Maybe<(
    { __typename?: 'UpdateSkillsPayload' }
    & { skills: Maybe<Array<Maybe<(
      { __typename?: 'Skill' }
      & Pick<Skill, 'id' | 'skill'>
    )>>> }
  )> }
);

export type UpdateWorkItemMutationVariables = {
  input: UpdateWorkItemInput
};


export type UpdateWorkItemMutation = (
  { __typename?: 'Mutation' }
  & { updateWorkItem: Maybe<(
    { __typename?: 'UpdateWorkItemPayload' }
    & { workItem: Maybe<(
      { __typename?: 'WorkHistoryV2' }
      & Pick<WorkHistoryV2, 'endMonth' | 'endYear' | 'isCurrent' | 'startMonth' | 'startYear' | 'summary' | 'title' | 'url' | 'urlDescription'>
      & { businessServices: Maybe<Array<(
        { __typename?: 'BusinessService' }
        & Pick<BusinessService, 'id' | 'isApproved' | 'name'>
      )>>, organisation: Maybe<(
        { __typename?: 'LegacyOrganisation' }
        & Pick<LegacyOrganisation, 'id' | 'name'>
      )>, expertOrganisations: Maybe<Array<(
        { __typename?: 'LegacyOrganisation' }
        & Pick<LegacyOrganisation, 'id' | 'name'>
      )>>, industries: Maybe<Array<Maybe<(
        { __typename?: 'Industry' }
        & Pick<Industry, 'id' | 'name'>
      )>>> }
    )> }
  )> }
);

export type ExpertProfileBuilderQueryVariables = {
  name?: Maybe<Scalars['String']>
};


export type ExpertProfileBuilderQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { businessServices: Maybe<(
      { __typename?: 'BusinessServiceConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'BusinessServiceEdge' }
        & { node: Maybe<(
          { __typename?: 'BusinessService' }
          & Pick<BusinessService, 'id' | 'name' | 'group'>
        )> }
      )>>> }
    )>, viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'id' | 'firstname' | 'lastname' | 'email' | 'phoneMobile' | 'currency' | 'source' | 'platformWhitelabelling' | 'profilePictureDomain'>
        & { profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )>, location: Maybe<(
          { __typename?: 'LegacyLocation' }
          & Pick<LegacyLocation, 'id' | 'city' | 'country'>
        )>, consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & Pick<ConsultantV2, 'id'>
          & { lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'id' | 'accepted' | 'declined' | 'basicProfileCompleted' | 'marketplaceMember' | 'privateCloudTalent'>
          )>, expertAvailability: Maybe<(
            { __typename?: 'AvailabilityV3' }
            & Pick<AvailabilityV3, 'currentAvailability' | 'unavailableUntilDate'>
          )>, profile: Maybe<(
            { __typename?: 'ProfileV2' }
            & Pick<ProfileV2, 'id' | 'availability' | 'summary' | 'headline' | 'code' | 'minHourlyRate' | 'maxHourlyRate' | 'minDailyRate' | 'maxDailyRate'>
            & { educationItems: Maybe<Array<(
              { __typename?: 'EducationItem' }
              & Pick<EducationItem, 'id' | 'schoolName' | 'degree' | 'startYear' | 'endYear' | 'fieldOfStudy' | 'description'>
            )>>, industries: Maybe<Array<(
              { __typename?: 'Industry' }
              & Pick<Industry, 'name'>
            )>>, skills: Maybe<Array<(
              { __typename?: 'Skill' }
              & Pick<Skill, 'id' | 'skill'>
            )>> }
          )>, workHistory: Maybe<(
            { __typename?: 'WorkHistoryV2Connection' }
            & { edges: Maybe<Array<Maybe<(
              { __typename?: 'WorkHistoryV2Edge' }
              & { node: Maybe<(
                { __typename?: 'WorkHistoryV2' }
                & Pick<WorkHistoryV2, 'id' | 'endMonth' | 'endYear' | 'isCurrent' | 'startMonth' | 'startYear' | 'summary' | 'title' | 'url' | 'urlDescription'>
                & { organisation: Maybe<(
                  { __typename?: 'LegacyOrganisation' }
                  & Pick<LegacyOrganisation, 'id' | 'name'>
                )>, expertOrganisations: Maybe<Array<(
                  { __typename?: 'LegacyOrganisation' }
                  & Pick<LegacyOrganisation, 'id' | 'name'>
                )>>, businessServices: Maybe<Array<(
                  { __typename?: 'BusinessService' }
                  & Pick<BusinessService, 'id' | 'group' | 'isApproved' | 'name'>
                )>>, industries: Maybe<Array<Maybe<(
                  { __typename?: 'Industry' }
                  & Pick<Industry, 'id' | 'name'>
                )>>> }
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertBusinessDetailsMutationVariables = {
  input: UpdateExpertBusinessDetailsInput
};


export type UpdateExpertBusinessDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertBusinessDetails: Maybe<(
    { __typename?: 'UpdateExpertBusinessDetailsPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { paymentInformation: Maybe<(
          { __typename?: 'PaymentInformationV2' }
          & Pick<PaymentInformationV2, 'operatingType' | 'registeredBusinessName' | 'abn' | 'acn'>
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertContactDetailsMutationVariables = {
  input: UpdateExpertContactDetailsInput
};


export type UpdateExpertContactDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertContactDetails: Maybe<(
    { __typename?: 'UpdateExpertContactDetailsPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & Pick<UserV2, 'phoneMobile'>
    )> }
  )> }
);

export type UpdateExpertInsuranceDeclarationMutationVariables = {
  input: UpdateExpertInsuranceDeclarationInput
};


export type UpdateExpertInsuranceDeclarationMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertInsuranceDeclaration: Maybe<(
    { __typename?: 'UpdateExpertInsuranceDeclarationPayload' }
    & Pick<UpdateExpertInsuranceDeclarationPayload, 'clientMutationId'>
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { insuranceInformation: Maybe<(
          { __typename?: 'InsuranceInformation' }
          & Pick<InsuranceInformation, 'hasInsurance' | 'workersCompensationCover' | 'publicLiabilityLimitInMillion' | 'professionalIndemnityLimitInMillion'>
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertProfilePrivacyMutationVariables = {
  input: UpdateExpertProfilePrivacyInput
};


export type UpdateExpertProfilePrivacyMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertProfilePrivacy: Maybe<(
    { __typename?: 'UpdateExpertProfilePrivacyPayload' }
    & Pick<UpdateExpertProfilePrivacyPayload, 'clientMutationId'>
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & Pick<ConsultantV2, 'profilePrivacy' | 'isPrivateCloudMember'>
        & { memberOf: Array<(
          { __typename?: 'Organisation' }
          & Pick<Organisation, 'name'>
        )> }
      )> }
    )> }
  )> }
);

export type UpdateExpertTaxSettingsMutationVariables = {
  input: UpdateExpertTaxSettingsInput
};


export type UpdateExpertTaxSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertTaxSettings: Maybe<(
    { __typename?: 'UpdateExpertTaxSettingsPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { paymentInformation: Maybe<(
          { __typename?: 'PaymentInformationV2' }
          & Pick<PaymentInformationV2, 'ausResident' | 'gstRegistered'>
        )> }
      )> }
    )> }
  )> }
);

export type ContactDetailsQueryVariables = {};


export type ContactDetailsQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'id' | 'email' | 'phoneMobile' | 'platformWhitelabelling'>
        & { location: Maybe<(
          { __typename?: 'LegacyLocation' }
          & Pick<LegacyLocation, 'countryCode'>
        )>, consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type InsuranceQueryVariables = {};


export type InsuranceQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'platformWhitelabelling'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { insuranceInformation: Maybe<(
            { __typename?: 'InsuranceInformation' }
            & Pick<InsuranceInformation, 'hasInsurance' | 'workersCompensationCover' | 'publicLiabilityLimitInMillion' | 'professionalIndemnityLimitInMillion'>
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type PaymentMethodQueryVariables = {};


export type PaymentMethodQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'id' | 'platformWhitelabelling'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { paymentInformation: Maybe<(
            { __typename?: 'PaymentInformationV2' }
            & Pick<PaymentInformationV2, 'ausResident' | 'bankAccountType' | 'operatingType' | 'isLegallyAuthorised' | 'paypalEmail'>
            & { ausBankAccount: Maybe<(
              { __typename?: 'BankAccountAus' }
              & Pick<BankAccountAus, 'accountName' | 'bsb'>
            )>, insuranceInformation: Maybe<(
              { __typename?: 'InsuranceInformation' }
              & Pick<InsuranceInformation, 'hasInsurance' | 'professionalIndemnityLimitInMillion' | 'publicLiabilityLimitInMillion' | 'workersCompensationCover'>
            )>, internationalBankAccount: Maybe<(
              { __typename?: 'BankAccountInternational' }
              & Pick<BankAccountInternational, 'accountName' | 'beneficiaryAddress' | 'swiftCode'>
            )>, usBankAccount: Maybe<(
              { __typename?: 'BankAccountUs' }
              & Pick<BankAccountUs, 'accountTitle' | 'beneficiaryAddress' | 'routingNumber' | 'swiftCode'>
            )> }
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ProfileVisibilityQueryVariables = {};


export type ProfileVisibilityQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'platformWhitelabelling'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & Pick<ConsultantV2, 'profilePrivacy' | 'isPrivateCloudMember'>
          & { memberOf: Array<(
            { __typename?: 'Organisation' }
            & Pick<Organisation, 'name'>
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type TaxQueryVariables = {};


export type TaxQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'id' | 'platformWhitelabelling'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { paymentInformation: Maybe<(
            { __typename?: 'PaymentInformationV2' }
            & Pick<PaymentInformationV2, 'ausResident' | 'gstRegistered'>
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type YourBusinessQueryVariables = {};


export type YourBusinessQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'platformWhitelabelling'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { paymentInformation: Maybe<(
            { __typename?: 'PaymentInformationV2' }
            & Pick<PaymentInformationV2, 'operatingType' | 'registeredBusinessName' | 'abn' | 'acn'>
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'marketplaceMember'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ReviewTimesheetAnonymouslyMutationVariables = {
  input: ReviewTimesheetAnonymouslyInput
};


export type ReviewTimesheetAnonymouslyMutation = (
  { __typename?: 'Mutation' }
  & { reviewTimesheetAnonymously: Maybe<(
    { __typename?: 'ReviewTimesheetAnonymouslyPayload' }
    & Pick<ReviewTimesheetAnonymouslyPayload, 'alreadyReviewed'>
  )> }
);

export type PaymentDashboardQueryVariables = {
  startDate: Scalars['String']
};


export type PaymentDashboardQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { invoices: Maybe<(
      { __typename?: 'PaymentInvoiceConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'PaymentInvoiceEdge' }
        & { node: Maybe<(
          { __typename?: 'PaymentInvoice' }
          & Pick<PaymentInvoice, 'id' | 'code' | 'status' | 'dateCreated' | 'expectedDatePaid' | 'dateStatusUpdated' | 'timesheetSubtotal' | 'deliverableSubtotal' | 'expenseTotal' | 'total' | 'organisationName'>
          & { project: Maybe<(
            { __typename?: 'ProjectV2' }
            & Pick<ProjectV2, 'hash' | 'title'>
            & { currentContract: Maybe<(
              { __typename?: 'Contract' }
              & Pick<Contract, 'currency'>
            )> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type ReviewTimesheetAnonymouslyQueryVariables = {};


export type ReviewTimesheetAnonymouslyQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'role'>
      )> }
    )> }
  )> }
);

export type LegalDocumentationQueryVariables = {
  type?: Maybe<Scalars['String']>
};


export type LegalDocumentationQuery = (
  { __typename?: 'Query' }
  & { legalDocumentation: Maybe<(
    { __typename?: 'OrganisationLegalDocumentation' }
    & Pick<OrganisationLegalDocumentation, 'document' | 'type'>
  )> }
);

export type ApproveContractOfferQueryVariables = {
  email?: Maybe<Scalars['String']>
};


export type ApproveContractOfferQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & Pick<V2, 'isAccountClaimed'>
  )> }
);

export type ApproveContractOfferMutationVariables = {
  input: ApproveContractOfferInput
};


export type ApproveContractOfferMutation = (
  { __typename?: 'Mutation' }
  & { approveContractOffer: Maybe<(
    { __typename?: 'ApproveContractOfferPayload' }
    & Pick<ApproveContractOfferPayload, 'alreadyApproved'>
  )> }
);

export type SubmitWorkingRightsDeclarationMutationVariables = {
  input: SubmitWorkingRightsDeclarationInput
};


export type SubmitWorkingRightsDeclarationMutation = (
  { __typename?: 'Mutation' }
  & { submitWorkingRightsDeclaration: Maybe<(
    { __typename?: 'SubmitWorkingRightsDeclarationPayload' }
    & Pick<SubmitWorkingRightsDeclarationPayload, 'workingRights' | 'workingRightsDeclarationDate'>
  )> }
);

export type ArchivedCompletedCard_GraphFragment = (
  { __typename?: 'ProjectV2' }
  & Pick<ProjectV2, 'code' | 'hash' | 'title' | 'unlisted' | 'companyType' | 'companyName' | 'industry' | 'locationType'>
  & { industries: Array<(
    { __typename?: 'Industry' }
    & Pick<Industry, 'name'>
  )>, locationDetails: Maybe<(
    { __typename?: 'LegacyLocation' }
    & Pick<LegacyLocation, 'city' | 'country'>
  )>, organisations: Maybe<Array<(
    { __typename?: 'Organisation' }
    & Pick<Organisation, 'id' | 'name'>
  )>>, viewerContract: Maybe<(
    { __typename?: 'Contract' }
    & Pick<Contract, 'code' | 'title' | 'agreedDate' | 'amount' | 'budgetType' | 'budgetUnit' | 'currency' | 'startDate' | 'endDate' | 'createdDate' | 'status'>
  )> }
);

export type ArchivedCompletedCard_ConsultantFragment = (
  { __typename?: 'ConsultantV2' }
  & { memberOf: Array<(
    { __typename?: 'Organisation' }
    & Pick<Organisation, 'name' | 'id'>
  )>, profile: Maybe<(
    { __typename?: 'ProfileV2' }
    & Pick<ProfileV2, 'code'>
  )> }
);

export type RequestPasswordResetMutationVariables = {
  input: RequestPasswordResetInput
};


export type RequestPasswordResetMutation = (
  { __typename?: 'Mutation' }
  & { requestPasswordReset: Maybe<(
    { __typename?: 'RequestPasswordResetPayload' }
    & Pick<RequestPasswordResetPayload, 'confirmation' | 'hasSso' | 'requireSso'>
  )> }
);

export type FindExpertsRenderer_GraphFragment = (
  { __typename?: 'Query' }
  & { experts: Maybe<(
    { __typename?: 'SearchConsultantConnection' }
    & Pick<SearchConsultantConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Maybe<Array<Maybe<(
      { __typename?: 'SearchConsultantEdge' }
      & { node: Maybe<(
        { __typename?: 'SearchConsultant' }
        & Pick<SearchConsultant, 'id' | 'name' | 'rating' | 'currency' | 'profileUrl' | 'skills' | 'currentAvailability' | 'dateAvailable'>
        & { organisations: Maybe<Array<(
          { __typename?: 'SearchOrganisation' }
          & Pick<SearchOrganisation, 'orgId' | 'name'>
        )>>, profile: (
          { __typename?: 'SearchConsultantProfile' }
          & Pick<SearchConsultantProfile, 'headline' | 'projectCount' | 'minDailyRate' | 'maxDailyRate' | 'organisationNames'>
          & { location: Maybe<(
            { __typename?: 'SearchLocation' }
            & Pick<SearchLocation, 'city' | 'country'>
          )>, workItems: Maybe<Array<(
            { __typename?: 'SearchWorkItem' }
            & { organisation: Maybe<(
              { __typename?: 'SearchOrganisation' }
              & Pick<SearchOrganisation, 'name'>
            )> }
          )>> }
        ), profilePicture: Maybe<(
          { __typename?: 'ProfilePicture' }
          & Pick<ProfilePicture, 'source'>
        )>, backOffice: Maybe<(
          { __typename?: 'BackOffice' }
          & Pick<BackOffice, 'isFutured' | 'isLocked' | 'isPrivate' | 'backOfficeLink' | 'dateLastInteracted' | 'dateUserLastUpdated' | 'dateRegistered' | 'dateLastLogin' | 'dateAvailabilityUpdated' | 'dateLastActivity'>
        )>, currentProject: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id' | 'status' | 'summary' | 'dateEnd'>
        )> }
      )> }
    )>>> }
  )> }
);

export type FindExpertsRendererRefetchQueryVariables = {
  first: Scalars['Int'],
  after?: Maybe<Scalars['String']>,
  filters?: Maybe<ExpertFilterInput>
};


export type FindExpertsRendererRefetchQuery = (
  { __typename?: 'Query' }
  & FindExpertsRenderer_GraphFragment
);

export type FindExpertsRendererQueryVariables = {
  first: Scalars['Int'],
  after?: Maybe<Scalars['String']>,
  filters?: Maybe<ExpertFilterInput>
};


export type FindExpertsRendererQuery = (
  { __typename?: 'Query' }
  & FindExpertsRenderer_GraphFragment
);

export type CompaniesTypeaheadQueryVariables = {
  company: Scalars['String']
};


export type CompaniesTypeaheadQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { legacyOrganisations: Maybe<(
      { __typename?: 'LegacyOrganisationConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'LegacyOrganisationEdge' }
        & { node: Maybe<(
          { __typename?: 'LegacyOrganisation' }
          & Pick<LegacyOrganisation, 'id' | 'name'>
        )> }
      )>>> }
    )> }
  )> }
);

export type CountriesQueryVariables = {};


export type CountriesQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { countries: Maybe<Array<Maybe<(
      { __typename?: 'Country' }
      & Pick<Country, 'name' | 'alpha2Code'>
    )>>> }
  )> }
);

export type CountryByCodeQueryVariables = {
  countryCode: Scalars['String']
};


export type CountryByCodeQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { countries: Maybe<Array<Maybe<(
      { __typename?: 'Country' }
      & Pick<Country, 'alpha2Code' | 'name'>
    )>>> }
  )> }
);

export type CountryByNameQueryVariables = {
  name: Scalars['String']
};


export type CountryByNameQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { countries: Maybe<Array<Maybe<(
      { __typename?: 'Country' }
      & Pick<Country, 'alpha2Code' | 'name'>
    )>>> }
  )> }
);

export type DisciplinesQueryVariables = {
  discipline?: Maybe<Scalars['String']>
};


export type DisciplinesQuery = (
  { __typename?: 'Query' }
  & { disciplines: Maybe<(
    { __typename?: 'DisciplineConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'DisciplineEdge' }
      & { node: Maybe<(
        { __typename?: 'Discipline' }
        & Pick<Discipline, 'id' | 'name'>
      )> }
    )>>> }
  )> }
);

export type IndustryTypeaheadQueryVariables = {
  name: Scalars['String']
};


export type IndustryTypeaheadQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { industryAutocomplete: Maybe<(
      { __typename?: 'IndustryConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'IndustryEdge' }
        & { node: Maybe<(
          { __typename?: 'Industry' }
          & Pick<Industry, 'id' | 'name' | 'parentName' | 'parentId'>
        )> }
      )>>> }
    )> }
  )> }
);

export type LegacyOrganisationsQueryVariables = {
  name: Scalars['String']
};


export type LegacyOrganisationsQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { legacyOrganisations: Maybe<(
      { __typename?: 'LegacyOrganisationConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'LegacyOrganisationEdge' }
        & { node: Maybe<(
          { __typename?: 'LegacyOrganisation' }
          & Pick<LegacyOrganisation, 'id' | 'name'>
        )> }
      )>>> }
    )> }
  )> }
);

export type LocationQueryVariables = {
  id: Scalars['ID']
};


export type LocationQuery = (
  { __typename?: 'Query' }
  & { node: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id'>
  ) | (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) | (
    { __typename?: 'LegacyLocation' }
    & Pick<LegacyLocation, 'city' | 'country' | 'countryCode' | 'subdivision' | 'id'>
  ) | (
    { __typename?: 'Organisation' }
    & Pick<Organisation, 'id'>
  ) | (
    { __typename?: 'Industry' }
    & Pick<Industry, 'id'>
  ) | (
    { __typename?: 'OrganisationDomain' }
    & Pick<OrganisationDomain, 'id'>
  ) | (
    { __typename?: 'RateCardRole' }
    & Pick<RateCardRole, 'id'>
  ) | (
    { __typename?: 'SsoConfig' }
    & Pick<SsoConfig, 'id'>
  ) | (
    { __typename?: 'RatingAndReview' }
    & Pick<RatingAndReview, 'id'>
  ) | (
    { __typename?: 'Contract' }
    & Pick<Contract, 'id'>
  ) | (
    { __typename?: 'Contact' }
    & Pick<Contact, 'id'>
  ) | (
    { __typename?: 'Discipline' }
    & Pick<Discipline, 'id'>
  ) | (
    { __typename?: 'SearchConsultant' }
    & Pick<SearchConsultant, 'id'>
  ) | (
    { __typename?: 'EventV2' }
    & Pick<EventV2, 'id'>
  ) | (
    { __typename?: 'OrganisationLegalDocumentation' }
    & Pick<OrganisationLegalDocumentation, 'id'>
  ) | (
    { __typename?: 'Profile' }
    & Pick<Profile, 'id'>
  ) | (
    { __typename?: 'EducationItem' }
    & Pick<EducationItem, 'id'>
  ) | (
    { __typename?: 'Skill' }
    & Pick<Skill, 'id'>
  ) | (
    { __typename?: 'WorkItem' }
    & Pick<WorkItem, 'id'>
  ) | (
    { __typename?: 'BusinessService' }
    & Pick<BusinessService, 'id'>
  ) | (
    { __typename?: 'LegacyOrganisation' }
    & Pick<LegacyOrganisation, 'id'>
  ) | (
    { __typename?: 'SearchProject' }
    & Pick<SearchProject, 'id'>
  ) | (
    { __typename?: 'ApplicationV2' }
    & Pick<ApplicationV2, 'id'>
  ) | (
    { __typename?: 'UserV2' }
    & Pick<UserV2, 'id'>
  ) | (
    { __typename?: 'ProjectV2' }
    & Pick<ProjectV2, 'id'>
  ) | (
    { __typename?: 'Deliverable' }
    & Pick<Deliverable, 'id'>
  ) | (
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id'>
  ) | (
    { __typename?: 'LegacyApplicationV2' }
    & Pick<LegacyApplicationV2, 'id'>
  ) | (
    { __typename?: 'ConsultantV2' }
    & Pick<ConsultantV2, 'id'>
  ) | (
    { __typename?: 'Lifecycle' }
    & Pick<Lifecycle, 'id'>
  ) | (
    { __typename?: 'ProfileV2' }
    & Pick<ProfileV2, 'id'>
  ) | (
    { __typename?: 'WorkHistoryV2' }
    & Pick<WorkHistoryV2, 'id'>
  ) | (
    { __typename?: 'ApplicationExperienceV2' }
    & Pick<ApplicationExperienceV2, 'id'>
  ) | (
    { __typename?: 'Thread' }
    & Pick<Thread, 'id'>
  ) | (
    { __typename?: 'Message' }
    & Pick<Message, 'id'>
  ) | (
    { __typename?: 'Country' }
    & Pick<Country, 'id'>
  ) | (
    { __typename?: 'OrganisationInvitation' }
    & Pick<OrganisationInvitation, 'id'>
  ) | (
    { __typename?: 'RoleTitle' }
    & Pick<RoleTitle, 'id'>
  ) | (
    { __typename?: 'Viewer' }
    & Pick<Viewer, 'id'>
  )> }
);

export type LocationsTypeaheadQueryVariables = {
  name?: Maybe<Scalars['String']>
};


export type LocationsTypeaheadQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { legacyLocations: Maybe<(
      { __typename?: 'LegacyLocationConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'LegacyLocationEdge' }
        & { node: Maybe<(
          { __typename?: 'LegacyLocation' }
          & Pick<LegacyLocation, 'id' | 'city' | 'subdivision' | 'country'>
        )> }
      )>>> }
    )> }
  )> }
);

export type RoleTitlesQueryVariables = {
  name?: Maybe<Scalars['String']>
};


export type RoleTitlesQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { roleTitles: Maybe<(
      { __typename?: 'RoleTitleConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'RoleTitleEdge' }
        & { node: Maybe<(
          { __typename?: 'RoleTitle' }
          & Pick<RoleTitle, 'id' | 'name'>
        )> }
      )>>> }
    )> }
  )> }
);

export type SkillTypeaheadQueryVariables = {
  skill: Scalars['String']
};


export type SkillTypeaheadQuery = (
  { __typename?: 'Query' }
  & { skills: Maybe<(
    { __typename?: 'SkillConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'SkillEdge' }
      & { node: Maybe<(
        { __typename?: 'Skill' }
        & Pick<Skill, 'id' | 'skill'>
      )> }
    )>>> }
  )> }
);

export type MatchOrganisationFromEmailQueryVariables = {
  email: Scalars['String']
};


export type MatchOrganisationFromEmailQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { organisation: Maybe<(
      { __typename?: 'Organisation' }
      & Pick<Organisation, 'id' | 'name'>
    )> }
  )> }
);

export type ClientOrganisationTypeaheadQueryVariables = {
  name?: Maybe<Scalars['String']>
};


export type ClientOrganisationTypeaheadQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { organisations: Maybe<(
      { __typename?: 'OrganisationConnection' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'OrganisationEdge' }
        & { node: Maybe<(
          { __typename?: 'Organisation' }
          & Pick<Organisation, 'id' | 'name'>
          & { organisationDomains: Maybe<Array<Maybe<(
            { __typename?: 'OrganisationDomain' }
            & Pick<OrganisationDomain, 'regex' | 'matchSignup'>
          )>>> }
        )> }
      )>>> }
    )> }
  )> }
);

export type ExpertApplicationQueryVariables = {};


export type ExpertApplicationQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { viewer: Maybe<(
      { __typename?: 'ViewerV2' }
      & { user: Maybe<(
        { __typename?: 'UserV2' }
        & Pick<UserV2, 'firstname' | 'uploadedCv' | 'operatingType' | 'applicationNotes' | 'workingSituation'>
        & { consultant: Maybe<(
          { __typename?: 'ConsultantV2' }
          & { paymentInformation: Maybe<(
            { __typename?: 'PaymentInformationV2' }
            & Pick<PaymentInformationV2, 'registeredBusinessName'>
          )>, profile: Maybe<(
            { __typename?: 'ProfileV2' }
            & Pick<ProfileV2, 'id' | 'code' | 'hash' | 'vettedIntoMarketplace' | 'linkedinUrl' | 'websiteUrl'>
          )>, lifecycle: Maybe<(
            { __typename?: 'Lifecycle' }
            & Pick<Lifecycle, 'accepted' | 'declined' | 'emailVerified' | 'applicationStep' | 'applicationCompleted' | 'basicProfileCompleted' | 'marketplaceMember' | 'privateCloudTalent'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ExpertSignUpQueryVariables = {};


export type ExpertSignUpQuery = (
  { __typename?: 'Query' }
  & { v2: Maybe<(
    { __typename?: 'V2' }
    & { countries: Maybe<Array<Maybe<(
      { __typename?: 'Country' }
      & Pick<Country, 'name' | 'alpha2Code'>
    )>>> }
  )> }
);

export type SubmitExpertApplicationMutationVariables = {
  input: SubmitExpertApplicationInput
};


export type SubmitExpertApplicationMutation = (
  { __typename?: 'Mutation' }
  & { submitExpertApplication: Maybe<(
    { __typename?: 'SubmitExpertApplicationPayload' }
    & { user: Maybe<(
      { __typename?: 'UserV2' }
      & Pick<UserV2, 'firstname' | 'publicCode' | 'uploadedCv' | 'operatingType' | 'applicationNotes' | 'workingSituation'>
      & { consultant: Maybe<(
        { __typename?: 'ConsultantV2' }
        & { paymentInformation: Maybe<(
          { __typename?: 'PaymentInformationV2' }
          & Pick<PaymentInformationV2, 'registeredBusinessName'>
        )>, profile: Maybe<(
          { __typename?: 'ProfileV2' }
          & Pick<ProfileV2, 'code' | 'id' | 'hash' | 'vettedIntoMarketplace' | 'linkedinUrl' | 'websiteUrl'>
        )>, lifecycle: Maybe<(
          { __typename?: 'Lifecycle' }
          & Pick<Lifecycle, 'accepted' | 'declined' | 'applicationStep' | 'applicationCompleted'>
        )> }
      )> }
    )> }
  )> }
);
